import rn, { forwardRef as b, createElement as Ei, useState as k, useEffect as z, cloneElement as N, useRef as E, useMemo as Fe, createContext as be, useCallback as H, Fragment as Ft, useContext as Ge, isValidElement as $t, useReducer as Pi, useLayoutEffect as Hn, Children as Mi, memo as $e, useImperativeHandle as Li } from "react";
import { jsx as n, jsxs as h, Fragment as j } from "react/jsx-runtime";
import g from "classnames";
import { useDelayGroupContext as Zn, useFloating as nt, offset as it, flip as lt, shift as rt, arrow as Bn, autoUpdate as ot, useInteractions as at, useHover as Ht, useFocus as Vn, useRole as st, useDismiss as ct, useDelayGroup as jn, FloatingPortal as We, useFloatingTree as Ti, useFloatingNodeId as Ai, useFloatingParentNodeId as Gn, size as Oi, safePolygon as Wn, useClick as qn, useListNavigation as Fi, useTypeahead as $i, FloatingNode as Hi, FloatingTree as Zi, useTransitionStatus as Bi, useMergeRefs as Vi, FloatingOverlay as Un, FloatingFocusManager as dt, useId as Zt } from "@floating-ui/react";
import Kn from "react-merge-refs";
import Qn from "react-keyed-flatten-children";
import ji from "react-highlight-words";
import Gi, { components as ut } from "react-select";
import Wi from "react-select/async";
import qi from "react-select/creatable";
import { parseDate as Ui } from "@internationalized/date";
import { DateField as Ki, DateInput as Qi, DateSegment as Yi } from "react-aria-components";
import { getDay as Ji, getDaysInMonth as on, sub as Xe, add as pe, isSameDay as bt, format as de, isBefore as Yn, isWithinInterval as Jn, isSameMonth as an, addQuarters as Xi, getYear as sn } from "date-fns";
import { Virtuoso as el } from "react-virtuoso";
import * as B from "@radix-ui/react-select";
import "@ag-grid-community/styles/ag-grid.min.css";
import "@ag-grid-community/styles/ag-theme-quartz.min.css";
import { ClientSideRowModelModule as tl } from "@ag-grid-community/client-side-row-model";
import { AgGridReact as nl } from "@ag-grid-community/react";
import { RangeSelectionModule as il } from "@ag-grid-enterprise/range-selection";
import { RowGroupingModule as ll } from "@ag-grid-enterprise/row-grouping";
import { ServerSideRowModelModule as rl } from "@ag-grid-enterprise/server-side-row-model";
import { RowNode as cn } from "@ag-grid-community/core";
import { DateTime as Se } from "luxon";
import { LicenseManager as ol } from "@ag-grid-enterprise/core";
function ne({
  size: e = "32",
  title: t,
  titleId: i,
  ...l
}) {
  return {
    width: e,
    height: e,
    ...t ? { title: t, titleId: i, role: "img" } : { "aria-hidden": !0 },
    ...l
  };
}
function Xn(e, t, i) {
  return {
    style: {
      ...i,
      rotate: t[e]
    }
  };
}
const al = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M12.668 20.545 7.805 15.53 6.37 16.923l6.277 6.473 12.032-12.032-1.415-1.414-10.595 10.595Z",
    clipRule: "evenodd"
  })]
});
function ei(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(al, {
    ...t
  });
}
const sl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm-4.293 11.364 2.829 2.828 6.364-6.364 1.414 1.415-7.778 7.778-4.243-4.243 1.414-1.414Z",
    clipRule: "evenodd"
  })]
});
function ti(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(sl, {
    ...t
  });
}
const cl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "m16 17.586 5.293-5.293 1.414 1.414-6 6-.707.707-.707-.707-6-6 1.414-1.414L16 17.586Z",
    clipRule: "evenodd"
  })]
});
function ee({
  direction: e = "down",
  ...t
}) {
  const i = ne(t), l = Xn(e, {
    up: "180deg",
    right: "270deg",
    down: "0deg",
    left: "90deg"
  });
  return /* @__PURE__ */ n(cl, {
    ...i,
    ...l
  });
}
const dl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M20.592 4.913h-9.184l-6.494 6.495v9.184l6.494 6.495h9.184l6.495-6.495v-9.184l-6.495-6.495Zm-3.436 12.698h-2.312V10.25h2.312v7.36Zm.094 3.889h-2.5v-2.491h2.5V21.5Z",
    clipRule: "evenodd"
  })]
});
function ul(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(dl, {
    ...t
  });
}
const hl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M28.291 25.047 15.945 2.891 3.599 25.047H28.29Zm-11.135-7.436h-2.312V10.25h2.312v7.36Zm.094 3.889h-2.5v-2.491h2.5V21.5Z",
    clipRule: "evenodd"
  })]
});
function _l(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(hl, {
    ...t
  });
}
const pl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm1.15 8.24h-2.32V10h2.32v2.24Zm0 9.872h-2.287v-8.48h2.288v8.48Z",
    clipRule: "evenodd"
  })]
});
function ml(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(pl, {
    ...t
  });
}
const fl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M20 14a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1.094 6.32a8 8 0 1 1 1.414-1.414l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387Z",
    clipRule: "evenodd"
  })]
});
function gl(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(fl, {
    ...t
  });
}
const vl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M21 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-5 17c3.576 0 6.79-1.545 9-4v-2a4 4 0 0 0-4-4H11a4 4 0 0 0-4 4v2c2.21 2.455 5.424 4 9 4Z",
    clipRule: "evenodd"
  })]
});
function bl(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(vl, {
    ...t
  });
}
const yl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    d: "m16 12-8 8h16l-8-8Z"
  })]
});
function ni({
  direction: e = "up",
  ...t
}) {
  const i = ne(t), l = Xn(e, {
    up: "0deg",
    right: "90deg",
    down: "180deg",
    left: "270deg"
  });
  return /* @__PURE__ */ n(yl, {
    ...i,
    ...l
  });
}
const wl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "m16 17.414 4.95 4.95 1.414-1.414-4.95-4.95 4.95-4.95-1.414-1.414-4.95 4.95-4.95-4.95-1.414 1.414 4.95 4.95-4.95 4.95 1.414 1.414 4.95-4.95Z",
    clipRule: "evenodd"
  })]
});
function ht(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(wl, {
    ...t
  });
}
const xl = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm-4.95 8.464L14.586 16l-3.536 3.535 1.414 1.415L16 17.414l3.536 3.536 1.414-1.415L17.414 16l3.536-3.536-1.414-1.414L16 14.586l-3.536-3.536-1.414 1.414Z",
    clipRule: "evenodd"
  })]
});
function Cl(e) {
  const t = ne(e);
  return /* @__PURE__ */ n(xl, {
    ...t
  });
}
const V = b(({
  component: e = "div",
  ...t
}, i) => Ei(e, {
  ...t,
  ref: i
})), Nl = "_avatar_17vfe_1", kl = "_interactive_17vfe_19", zl = "_image_17vfe_34", Dl = "_initials_17vfe_82", Rl = "_inset_17vfe_126", xe = {
  avatar: Nl,
  interactive: kl,
  "has-image": "_has-image_17vfe_26",
  image: zl,
  "size-16": "_size-16_17vfe_77",
  initials: Dl,
  "size-20": "_size-20_17vfe_88",
  "size-24": "_size-24_17vfe_98",
  "size-32": "_size-32_17vfe_108",
  "size-40": "_size-40_17vfe_117",
  inset: Rl
}, dn = {
  16: "16",
  20: "16",
  24: "20",
  32: "24",
  40: "32"
};
b(({
  children: e,
  component: t = "div",
  size: i = "32",
  name: l,
  initials: r,
  source: o,
  onError: a,
  icon: s,
  ...c
}, d) => {
  const [u, _] = k("PENDING");
  z(() => {
    _("PENDING");
  }, [o]);
  const p = () => {
    _("ERRORED"), a && a();
  }, m = () => _("LOADED"), f = o && u === "LOADED", y = i === "16" ? r == null ? void 0 : r[0] : r == null ? void 0 : r.slice(0, 2), w = t === "button" || t === "a", C = s ? N(s, {
    size: dn[i]
  }) : /* @__PURE__ */ n(bl, {
    size: dn[i]
  }), v = o && !f || !o && !r;
  return /* @__PURE__ */ h(V, {
    component: t,
    ...c,
    className: g(xe.avatar, w && xe.interactive, f && xe["has-image"], xe[`size-${i}`]),
    "aria-label": l || (r == null ? void 0 : r.split("").join(" ")),
    type: t === "button" ? "button" : void 0,
    ref: d,
    children: [v ? C : /* @__PURE__ */ n("span", {
      className: xe.initials,
      style: {
        opacity: u === "LOADED" ? "0" : void 0
      },
      children: y
    }), o ? /* @__PURE__ */ n("img", {
      className: xe.image,
      src: o,
      alt: "",
      onLoad: m,
      onError: p,
      style: {
        opacity: u !== "LOADED" ? "0" : void 0
      }
    }) : null, /* @__PURE__ */ n("div", {
      className: xe.inset
    })]
  });
});
const Sl = "_tooltip_1pnuu_1", Il = "_small_1pnuu_22", El = "_medium_1pnuu_30", Pl = "_large_1pnuu_39", Ml = "_content_1pnuu_48", Ll = "_label_1pnuu_58", Tl = "_shortcut_1pnuu_69", Al = "_arrow_1pnuu_81", Ie = {
  tooltip: Sl,
  small: Il,
  medium: El,
  large: Pl,
  content: Ml,
  label: Ll,
  shortcut: Tl,
  arrow: Al
}, un = {
  small: 3,
  medium: 4,
  large: 6
}, Ue = {
  small: 6,
  medium: 8,
  large: 10
}, ye = b(({
  children: e,
  label: t,
  shortcut: i,
  size: l = "medium",
  placement: r = "top",
  removeOffset: o,
  hideArrow: a = !1,
  initialOpen: s = !1
}, c) => {
  const d = E(null), [u, _] = k(s || !1), {
    delay: p,
    setCurrentId: m
  } = Zn(), {
    x: f,
    y,
    reference: w,
    floating: C,
    strategy: v,
    context: x,
    placement: D,
    refs: L,
    middlewareData: {
      arrow: {
        x: T,
        y: P,
        centerOffset: R
      } = {}
    }
  } = nt({
    placement: r,
    open: u,
    onOpenChange(ie) {
      _(ie), ie && m(t);
    },
    middleware: [it(un[l] + (o ? 0 : 4)), lt(), rt({
      padding: 4
    }), Bn({
      element: d
    })],
    whileElementsMounted: ot
  }), {
    getReferenceProps: Z,
    getFloatingProps: $
  } = at([Ht(x, {
    delay: p
  }), Vn(x), st(x, {
    role: "tooltip"
  }), ct(x, {
    referencePress: !0
  }), jn(x, {
    id: t
  })]), Y = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[D.split("-")[0]], J = Fe(() => Kn([w, c]), [w, c]), we = ["top", "bottom"].includes(Y != null ? Y : ""), F = we ? Ue[l] / 2 : Ue[l] + un[l], K = () => {
    var ie, le;
    const Re = we ? "width" : "height", S = ((le = (ie = L.reference.current) == null ? void 0 : ie.getBoundingClientRect()[Re]) != null ? le : 0) / 2;
    let A = R != null ? R : 0;
    return A < 0 && (A *= -1), A >= S - Ue[l];
  };
  return /* @__PURE__ */ h(j, {
    children: [N(e, Z({
      ref: J,
      "aria-label": u ? void 0 : t,
      ...e.props
    })), u ? /* @__PURE__ */ n(We, {
      children: /* @__PURE__ */ h("div", {
        ...$({
          ref: C,
          className: [Ie.tooltip, Ie[l]].join(" "),
          style: {
            position: v,
            top: y != null ? y : 0,
            left: f != null ? f : 0
          }
        }),
        children: [/* @__PURE__ */ h("div", {
          className: Ie.content,
          children: [/* @__PURE__ */ n("span", {
            className: Ie.label,
            children: t
          }), i ? /* @__PURE__ */ n("kbd", {
            className: Ie.shortcut,
            children: i
          }) : null]
        }), a ? null : /* @__PURE__ */ n("div", {
          ref: d,
          style: {
            position: "absolute",
            left: T != null ? T : "",
            top: P != null ? P : "",
            right: "",
            bottom: "",
            [Y]: `-${F}px`,
            opacity: K() ? "0" : "",
            padding: `0 ${Ue[l]}px`
          },
          children: /* @__PURE__ */ n("div", {
            className: Ie.arrow
          })
        })]
      })
    }) : null]
  });
});
ye.displayName = "Tooltip";
function ii(e) {
  const t = E(e);
  return z(() => {
    t.current = e;
  }), Fe(() => (...i) => {
    var l;
    return (l = t.current) == null ? void 0 : l.call(t, ...i);
  }, []);
}
function Ol({
  defaultProp: e,
  onChange: t
}) {
  const i = k(e), [l] = i, r = E(l), o = ii(t);
  return z(() => {
    r.current !== l && (o(l), r.current = l);
  }, [l, r, o]), i;
}
function _t({
  prop: e,
  defaultProp: t,
  onChange: i = () => {
  }
}) {
  const [l, r] = Ol({
    defaultProp: t,
    onChange: i
  }), o = e !== void 0, a = o ? e : l, s = ii(i), c = H(
    (d) => {
      if (o) {
        const u = typeof d == "function" ? d(e) : d;
        u !== e && s(u);
      } else
        r(d);
    },
    [o, e, r, s]
  );
  return [a, c];
}
function De(e = {}) {
  const {
    strict: t = !0,
    errorMessage: i = "useContext: `context` is undefined. This component must be wrapped within its Provider.",
    name: l
  } = e, r = rn.createContext(void 0);
  r.displayName = l;
  function o() {
    var a;
    const s = rn.useContext(r);
    if (!s && t) {
      const c = new Error(i);
      throw c.name = "ContextError", (a = Error.captureStackTrace) == null || a.call(Error, c, o), c;
    }
    return s;
  }
  return [
    r.Provider,
    o,
    r
  ];
}
const [Fl, li] = De({
  strict: !1,
  name: "HoverCardContext"
});
function $l({
  children: e,
  open: t,
  defaultOpen: i,
  onOpenChange: l,
  placement: r = "bottom"
}) {
  const [o, a] = _t({
    prop: t,
    defaultProp: i,
    onChange: l
  }), {
    delay: s,
    setCurrentId: c
  } = Zn(), d = E(null), u = Zt(), _ = `${u}-label`, p = `${u}-description`, {
    x: m,
    y: f,
    reference: y,
    floating: w,
    strategy: C,
    context: v,
    refs: x,
    middlewareData: {
      arrow: {
        x: D,
        y: L,
        centerOffset: T
      } = {}
    }
  } = nt({
    open: o,
    onOpenChange: (J) => {
      a(J), J && c(u);
    },
    middleware: [it(10), lt(), rt({
      padding: 4
    }), Bn({
      element: d
    })],
    placement: r,
    whileElementsMounted: ot
  }), {
    getReferenceProps: P,
    getFloatingProps: R
  } = at([Ht(v, {
    delay: s,
    handleClose: Wn()
  }), Vn(v), st(v), ct(v), jn(v, {
    id: u
  })]), Z = P({
    ref: y
  }), $ = R({
    ref: w,
    style: {
      position: C,
      top: f != null ? f : 0,
      left: m != null ? m : 0
    },
    "aria-labelledby": _,
    "aria-describedby": p
  }), Y = {
    open: o,
    setOpen: a,
    refs: {
      reference: x.reference
    },
    referenceProps: Z,
    arrowRef: d,
    arrowData: {
      arrowX: D,
      arrowY: L,
      centerOffset: T
    },
    floatingProps: $,
    floatingContext: v,
    labelId: _,
    descriptionId: p
  };
  return /* @__PURE__ */ n(Fl, {
    value: Y,
    children: e
  });
}
const Hl = "_contents_19lf7_1", Zl = "_arrow_19lf7_14", hn = {
  contents: Hl,
  arrow: Zl
};
function Bl({
  children: e,
  hideArrow: t = !1
}) {
  const i = li(), {
    placement: l
  } = i.floatingContext, {
    arrowX: r,
    arrowY: o,
    centerOffset: a
  } = i.arrowData, s = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[l.split("-")[0]], c = () => {
    var d, u;
    const _ = ((u = (d = i.refs.reference.current) == null ? void 0 : d.getBoundingClientRect().width) != null ? u : 0) / 2;
    let p = a != null ? a : 0;
    return p < 0 && (p *= -1), p >= _ - 10;
  };
  return i.open ? /* @__PURE__ */ n(We, {
    root: i.portalRoot,
    children: /* @__PURE__ */ n(dt, {
      context: i.floatingContext,
      order: ["floating", "content"],
      modal: !1,
      returnFocus: !1,
      children: /* @__PURE__ */ h("div", {
        className: hn.contents,
        ...i.floatingProps,
        children: [e, t ? null : /* @__PURE__ */ n("div", {
          ref: i.arrowRef,
          style: {
            position: "absolute",
            left: r != null ? r : "",
            top: o != null ? o : "",
            right: "",
            bottom: "",
            [s]: `-${10 / 2}px`,
            opacity: c() ? "0" : "",
            padding: `0 ${["left", "right"].includes(s) ? 0 : "10px"}`
          },
          children: /* @__PURE__ */ n("div", {
            className: hn.arrow
          })
        })]
      })
    })
  }) : null;
}
const Vl = b(({
  children: e
}, t) => {
  const i = li(), {
    ref: l,
    ...r
  } = i.referenceProps, o = Fe(() => Kn([l, t]), [l, t]);
  return N(e, {
    ref: o,
    ...r,
    ...e.props
  });
}), jl = "_root_js1y4_1", Gl = "_multiline_js1y4_9", _n = {
  root: jl,
  multiline: Gl
};
function Bt({
  children: e,
  lines: t
}) {
  return /* @__PURE__ */ n("span", {
    className: g(_n.root, t > 1 ? _n.multiline : void 0),
    style: t > 1 ? {
      "--ic-truncate-lines": String(t)
    } : void 0,
    children: e
  });
}
const Wl = "_text_maxmh_1", ql = "_display_maxmh_10", Ul = "_heading_maxmh_26", Kl = "_title_maxmh_42", Ql = "_body_maxmh_59", Yl = "_label_maxmh_60", Jl = "_code_maxmh_61", Xl = "_left_maxmh_87", er = "_center_maxmh_91", tr = "_right_maxmh_95", nr = "_medium_maxmh_99", ir = "_bold_maxmh_107", lr = "_black_maxmh_111", rr = "_primary_maxmh_115", or = "_secondary_maxmh_119", ar = "_tertiary_maxmh_123", sr = "_disabled_maxmh_127", cr = "_white_maxmh_131", dr = "_info_maxmh_135", ur = "_positive_maxmh_139", hr = "_critical_maxmh_143", Ee = {
  text: Wl,
  display: ql,
  "size-small": "_size-small_maxmh_13",
  "size-medium": "_size-medium_maxmh_17",
  "size-large": "_size-large_maxmh_21",
  heading: Ul,
  title: Kl,
  body: Ql,
  label: Yl,
  code: Jl,
  left: Xl,
  center: er,
  right: tr,
  medium: nr,
  "semi-bold": "_semi-bold_maxmh_103",
  bold: ir,
  black: lr,
  primary: rr,
  secondary: or,
  tertiary: ar,
  disabled: sr,
  white: cr,
  info: dr,
  positive: ur,
  critical: hr
}, ze = b(({
  children: e,
  as: t = "span",
  lines: i,
  variant: l = "body",
  size: r = "medium",
  align: o = "left",
  weight: a = "normal",
  tone: s = "primary",
  numeric: c,
  tabIndex: d,
  ...u
}, _) => {
  let p;
  l === "body" ? p = a : l === "code" ? p = a !== "normal" ? "bold" : a : p = "";
  const m = typeof i == "number" ? /* @__PURE__ */ n(Bt, {
    lines: i,
    children: e
  }) : e;
  return /* @__PURE__ */ n(V, {
    ...u,
    component: t,
    className: g(Ee.text, Ee[l], Ee[`size-${r}`], Ee[o], Ee[p], Ee[s]),
    style: {
      "--ic-text-numeric": c
    },
    tabIndex: d,
    ref: _,
    children: m
  });
});
function _r(e = 0, t = 99) {
  return Number.isNaN(e * 1) || Number.isNaN(t) ? "0" : e === 1 / 0 ? "\u221E" : t < e ? `${t}+` : `${e}`;
}
function pr(e) {
  return {
    __forwardRef__: b(e)
  };
}
const mr = pr((e, t) => /* @__PURE__ */ n("a", {
  ref: t,
  ...e
})), fr = be(mr), gr = () => {
  const e = Ge(fr);
  return "__forwardRef__" in e ? e.__forwardRef__ : e;
}, pt = b((e, t) => {
  const i = gr();
  return /* @__PURE__ */ n(i, {
    ref: t,
    ...e
  });
}), vr = "_count_1jg83_1", br = "_number_1jg83_13", yr = "_light_1jg83_29", wr = "_heavy_1jg83_36", yt = {
  count: vr,
  number: br,
  light: yr,
  heavy: wr
};
function ri({
  count: e,
  variant: t = "light"
}) {
  const i = _r(e, 999);
  return /* @__PURE__ */ n("div", {
    className: g(yt.count, yt[t]),
    children: /* @__PURE__ */ n("span", {
      className: yt.number,
      children: i
    })
  });
}
const xr = "_wrapper_13ln8_1", Cr = "_spinner_13ln8_5", Nr = "_spin_13ln8_5", kr = "_background_13ln8_12", wt = {
  wrapper: xr,
  spinner: Cr,
  spin: Nr,
  background: kr
}, pn = {
  xs: {
    diameter: 16,
    strokeWidth: 1.5
  },
  sm: {
    diameter: 24,
    strokeWidth: 2
  },
  md: {
    diameter: 32,
    strokeWidth: 2.5
  },
  lg: {
    diameter: 40,
    strokeWidth: 3
  }
};
function Mt({
  size: e = "sm"
}) {
  const {
    diameter: t
  } = pn[e], {
    strokeWidth: i
  } = pn[e], l = t / 2, r = Math.PI * (l - i);
  return /* @__PURE__ */ n("div", {
    className: wt.wrapper,
    "aria-label": "Loading",
    role: "status",
    "aria-live": "polite",
    children: /* @__PURE__ */ h("svg", {
      width: t,
      height: t,
      viewBox: `0 0 ${t} ${t}`,
      children: [/* @__PURE__ */ n("circle", {
        className: wt.background,
        cx: l,
        cy: l,
        r: l - i,
        strokeWidth: i,
        vectorEffect: "non-scaling-stroke"
      }), /* @__PURE__ */ n("circle", {
        style: {
          transformOrigin: `${l}px ${l}px`
        },
        className: wt.spinner,
        cx: l,
        cy: l,
        r: l - i,
        strokeDasharray: r,
        strokeWidth: i,
        vectorEffect: "non-scaling-stroke"
      })]
    })
  });
}
const zr = "_button_alxw7_4", Dr = "_full_alxw7_62", Rr = "_solid_alxw7_66", Sr = "_ghost_alxw7_97", Ir = "_muted_alxw7_139", Er = "_transparent_alxw7_170", Pr = "_custom_alxw7_202", Mr = "_background_alxw7_209", Lr = "_accent_alxw7_238", Tr = "_neutral_alxw7_251", Ar = "_positive_alxw7_268", Or = "_caution_alxw7_282", Fr = "_critical_alxw7_296", $r = "_sm_alxw7_310", Hr = "_contents_alxw7_314", Zr = "_md_alxw7_319", Br = "_lg_alxw7_328", Vr = "_text_alxw7_338", jr = "_suffix_alxw7_339", Gr = "_prefix_alxw7_359", Wr = "_indicator_alxw7_368", O = {
  button: zr,
  "is-icon-only": "_is-icon-only_alxw7_58",
  full: Dr,
  solid: Rr,
  ghost: Sr,
  muted: Ir,
  transparent: Er,
  custom: Pr,
  background: Mr,
  accent: Lr,
  neutral: Tr,
  positive: Ar,
  caution: Or,
  critical: Fr,
  sm: $r,
  contents: Hr,
  md: Zr,
  lg: Br,
  "is-pending": "_is-pending_alxw7_337",
  text: Vr,
  suffix: jr,
  prefix: Gr,
  indicator: Wr
}, ve = {
  sm: "16",
  md: "20",
  lg: "24"
}, mn = {
  sm: "xs",
  md: "xs",
  lg: "sm"
}, he = b(({
  tone: e = "neutral",
  variant: t = "muted",
  size: i = "md",
  prefix: l,
  suffix: r,
  fullWidth: o,
  disabled: a,
  onClick: s,
  pending: c,
  ...d
}, u) => {
  const [_, p] = k(!1);
  z(() => {
    let f;
    return c ? f = setTimeout(() => {
      p(!0);
    }, 1e3) : p(!1), () => {
      clearTimeout(f);
    };
  }, [c]);
  const m = (f) => {
    a || c || typeof s == "function" && s(f);
  };
  return /* @__PURE__ */ h("button", {
    ref: u,
    type: "button",
    ...d,
    className: g(O.button, t !== "custom" && O[e], O[t], O[i], o && O.full, _ && !l && O["is-pending"], !("children" in d) && !!l && O["is-icon-only"], d.className),
    "aria-disabled": a || c ? !0 : void 0,
    "aria-busy": c ? !0 : void 0,
    onClick: m,
    children: [t === "custom" ? /* @__PURE__ */ n("div", {
      className: O.background,
      style: {
        backgroundColor: a ? void 0 : e
      }
    }) : null, /* @__PURE__ */ h("span", {
      className: O.contents,
      children: [l ? /* @__PURE__ */ n("div", {
        className: O.prefix,
        style: {
          inlineSize: `${ve[i]}px`,
          blockSize: `${ve[i]}px`
        },
        children: _ ? /* @__PURE__ */ n("div", {
          className: O.indicator,
          children: /* @__PURE__ */ n(Mt, {
            size: mn[i]
          })
        }) : N(l, {
          size: ve[i]
        })
      }) : null, "children" in d ? /* @__PURE__ */ h(j, {
        children: [_ && !l ? /* @__PURE__ */ n("div", {
          className: O.indicator,
          children: /* @__PURE__ */ n(Mt, {
            size: mn[i]
          })
        }) : null, /* @__PURE__ */ n("span", {
          className: O.text,
          children: d.children
        })]
      }) : null, r ? /* @__PURE__ */ n("div", {
        className: O.suffix,
        children: /* @__PURE__ */ n(qr, {
          suffix: r,
          variant: t,
          size: i
        })
      }) : null]
    })]
  });
});
he.displayName = "Button";
function qr({
  suffix: e,
  variant: t,
  size: i
}) {
  return typeof e == "number" ? /* @__PURE__ */ n(ri, {
    count: e,
    variant: t === "solid" ? "heavy" : "light"
  }) : N(e, {
    size: ve[i]
  });
}
const Ur = "_root_i3kz0_1", Kr = "_sm_i3kz0_45", Qr = "_md_i3kz0_49", Yr = "_lg_i3kz0_53", Jr = "_subtle_i3kz0_57", fe = {
  root: Ur,
  sm: Kr,
  md: Qr,
  lg: Yr,
  subtle: Jr,
  "is-round": "_is-round_i3kz0_77"
}, Xr = b(({
  children: e,
  icon: t,
  variant: i = "standard",
  size: l = "md",
  round: r,
  onClick: o,
  disabled: a,
  ...s
}, c) => /* @__PURE__ */ h(V, {
  component: "button",
  ...s,
  ref: c,
  className: g(fe.root, fe[l], fe[i], r && fe["is-round"]),
  type: "button",
  onClick: a ? void 0 : o,
  "aria-disabled": a,
  children: [N(t, {
    size: ve[l]
  }), e]
})), G = b(({
  label: e,
  shortcut: t,
  placement: i = "top",
  ...l
}, r) => /* @__PURE__ */ n(ye, {
  ref: r,
  size: "large",
  removeOffset: !0,
  label: e,
  shortcut: t,
  placement: i,
  children: /* @__PURE__ */ n(Xr, {
    ...l
  })
}));
G.displayName = "IconButton";
function eo(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function Vt(...e) {
  return Fe(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((i) => {
      i && eo(i, t);
    });
  }, [e]);
}
const to = "_backdrop_1ajwk_1", jt = "_popover_1ajwk_5", no = "_constrained_1ajwk_26", xt = {
  backdrop: to,
  popover: jt,
  constrained: no
}, [io, oi] = De({
  strict: !1,
  name: "MenuContext"
}), fn = b(({
  children: e,
  open: t,
  defaultOpen: i,
  onOpenChange: l = () => {
  },
  placement: r = "bottom-start",
  verticalOffset: o = 4,
  tabIndex: a
}, s) => {
  const [c, d] = _t({
    prop: t,
    defaultProp: i,
    onChange: l
  }), [u, _] = k(null), [p, m] = k(!1), f = E([]), y = E([]), w = Ti(), C = Ai(), v = Gn(), x = v != null, {
    x: D,
    y: L,
    reference: T,
    floating: P,
    strategy: R,
    refs: Z,
    context: $
  } = nt({
    open: c,
    onOpenChange: d,
    middleware: [it({
      mainAxis: x ? 0 : o,
      alignmentAxis: x ? -13 : 0
    }), lt(), Oi({
      apply({
        availableHeight: S,
        elements: A
      }) {
        Object.assign(A.floating.style, {
          maxHeight: x ? "calc(100vh - 106px)" : `${S}px`
        });
      }
    }), rt({
      padding: x ? 40 : 0
    })],
    placement: x ? "right-start" : r,
    nodeId: C,
    whileElementsMounted: ot
  }), {
    getReferenceProps: Y,
    getFloatingProps: J,
    getItemProps: we
  } = at([Ht($, {
    handleClose: Wn({
      restMs: 25
    }),
    enabled: x && p,
    delay: {
      open: 75
    }
  }), qn($, {
    toggle: !x,
    event: "click",
    ignoreMouse: x
  }), st($, {
    role: "menu"
  }), ct($), Fi($, {
    listRef: f,
    activeIndex: u,
    onNavigate: _,
    nested: x
  }), $i($, {
    listRef: y,
    onMatch: c ? _ : void 0,
    activeIndex: u
  })]), F = Vt(s, T), K = Y({
    ref: F,
    onClick(S) {
      S.stopPropagation(), S.currentTarget.focus();
    },
    ...x ? {
      nested: x || void 0,
      open: c,
      role: "menuitem",
      tabIndex: a,
      onKeyDown(S) {
        (S.key === "ArrowUp" || S.key === "ArrowDown") && d(!1);
      }
    } : void 0
  }), ie = J({
    className: jt,
    ref: P,
    style: {
      position: R,
      top: L != null ? L : 0,
      left: D != null ? D : 0
    }
  }), le = (S, A) => we({
    role: "menuitem",
    ref(qe) {
      f.current[A] = qe;
    },
    tabIndex: u === A ? 0 : -1,
    onClick(qe) {
      var nn, ln;
      qe.stopPropagation(), (ln = (nn = S.props).onClick) == null || ln.call(nn, qe), w == null || w.events.emit("click");
    },
    onPointerEnter() {
      p && _(A);
    }
  }), Re = H(() => {
    y.current = f.current.map((S) => {
      var A;
      return (A = S == null ? void 0 : S.innerText) != null ? A : null;
    });
  }, [f]);
  return z(() => {
    var S;
    i && ((S = Z.reference.current) == null || S.focus());
  }, [i, Z]), z(() => {
    function S() {
      var A;
      d(!1), v === null && ((A = Z.reference.current) == null || A.focus());
    }
    return w == null || w.events.on("click", S), () => {
      w == null || w.events.off("click", S);
    };
  }, [v, w, Z, d]), z(() => {
    function S() {
      m(!0);
    }
    function A() {
      m(!1);
    }
    return window.addEventListener("pointermove", S, {
      once: !0,
      capture: !0
    }), window.addEventListener("keydown", A, !0), () => {
      window.removeEventListener("pointermove", S, {
        capture: !0
      }), window.removeEventListener("keydown", A, !0);
    };
  }, [p]), /* @__PURE__ */ n(Hi, {
    id: C,
    children: /* @__PURE__ */ n(io, {
      value: {
        open: c,
        nested: x,
        referenceProps: K,
        floatingProps: ie,
        itemProps: le,
        floatingContext: $,
        updateContent: Re
      },
      children: e
    })
  });
}), Gt = b((e, t) => Gn() == null ? /* @__PURE__ */ n(Zi, {
  children: /* @__PURE__ */ n(fn, {
    ...e,
    ref: t
  })
}) : /* @__PURE__ */ n(fn, {
  ...e,
  ref: t
})), lo = "_container_1yb5k_1", ro = "_divider_1yb5k_6", oo = "_inverted_1yb5k_12", Ct = {
  container: lo,
  divider: ro,
  inverted: oo
};
function te({
  vertical: e = !1,
  inverted: t
}) {
  return /* @__PURE__ */ n("div", {
    className: Ct.container,
    children: /* @__PURE__ */ n("div", {
      className: g(Ct.divider, t && Ct.inverted),
      role: "separator",
      "aria-orientation": e ? "vertical" : "horizontal"
    })
  });
}
const ai = "_heading_1jako_1", ao = "_item_1jako_15", so = "_icon_1jako_32", co = "_open_1jako_50", uo = "_text_1jako_66", ho = "_multiline_1jako_74", _o = "_content_1jako_77", po = "_description_1jako_88", mo = "_title_1jako_100", si = "_divider_1jako_107", M = {
  heading: ai,
  item: ao,
  icon: so,
  open: co,
  text: uo,
  multiline: ho,
  content: _o,
  description: po,
  title: mo,
  divider: si
};
function ci() {
  return /* @__PURE__ */ n("div", {
    className: si,
    children: /* @__PURE__ */ n(te, {})
  });
}
function Wt({
  children: e,
  id: t
}) {
  return /* @__PURE__ */ n("div", {
    className: ai,
    id: t,
    children: e
  });
}
function qt({
  children: e
}) {
  const t = oi();
  return z(() => t.updateContent(), [t]), t.open ? /* @__PURE__ */ n(We, {
    children: /* @__PURE__ */ n(dt, {
      context: t.floatingContext,
      returnFocus: !t.nested,
      modal: !t.nested,
      order: ["content"],
      initialFocus: t.nested ? -1 : 0,
      children: /* @__PURE__ */ n("div", {
        className: jt,
        ...t.floatingProps,
        children: Qn(e).map((i, l) => $t(i) && i.type !== Wt && i.type !== ci ? N(i, {
          ...t.itemProps(i, l)
        }) : i)
      })
    })
  }) : null;
}
const di = b(({
  children: e,
  ...t
}, i) => e(t, i)), ae = b(({
  children: e,
  ...t
}, i) => /* @__PURE__ */ n(di, {
  ...t,
  ref: i,
  children: ({
    nested: l,
    open: r,
    icon: o,
    reserveIconSpace: a,
    lozenge: s,
    ...c
  }, d) => /* @__PURE__ */ h(V, {
    component: c.href ? pt : "button",
    type: c.href ? void 0 : "button",
    className: g(M.item, r && M.open),
    ref: d,
    ...c,
    children: [o ? /* @__PURE__ */ n("div", {
      className: M.icon,
      children: N(o, {
        size: "24"
      })
    }) : /* @__PURE__ */ n("div", {
      style: {
        height: "24px",
        width: a ? "24px" : 0,
        flex: "none"
      }
    }), /* @__PURE__ */ h("div", {
      className: M.title,
      children: [/* @__PURE__ */ n("div", {
        className: M.text,
        children: e
      }), s ? N(s, {
        size: "sm"
      }) : null]
    }), l ? /* @__PURE__ */ n(ee, {
      size: "24",
      direction: "right"
    }) : null]
  })
}));
b(({
  children: e,
  ...t
}, i) => /* @__PURE__ */ n(di, {
  ...t,
  ref: i,
  children: ({
    nested: l,
    open: r,
    icon: o,
    lozenge: a,
    description: s,
    ...c
  }, d) => /* @__PURE__ */ h(V, {
    component: c.href ? pt : "button",
    type: c.href ? void 0 : "button",
    className: g(M.item, M.multiline, r && M.open),
    ref: d,
    ...c,
    children: [o && /* @__PURE__ */ n("div", {
      className: M.icon,
      children: N(o, {
        size: "32"
      })
    }), /* @__PURE__ */ h("div", {
      className: M.content,
      children: [/* @__PURE__ */ h("div", {
        className: M.title,
        children: [/* @__PURE__ */ n("div", {
          className: M.text,
          children: e
        }), a ? N(a, {
          size: "sm"
        }) : null]
      }), /* @__PURE__ */ n("div", {
        className: M.description,
        children: s
      })]
    }), l ? /* @__PURE__ */ n(ee, {
      size: "24",
      direction: "right"
    }) : null]
  })
}));
function mt(e, t, { checkForDefaultPrevented: i = !0 } = {}) {
  return function(l) {
    e == null || e(l), (i === !1 || !l.defaultPrevented) && (t == null || t(l));
  };
}
const ft = b(({
  children: e,
  ...t
}, i) => {
  const l = oi(), {
    ref: r,
    onClick: o,
    ...a
  } = l.referenceProps, s = Vt(i, r), c = {
    ...a,
    ...t,
    ref: s,
    onClick: mt(t.onClick, o)
  };
  return typeof e == "function" ? e(c) : N(e, c);
});
ft.displayName = "MenuTrigger";
const fo = "_button_1bpcc_1", go = {
  button: fo
}, vo = b(({
  children: e,
  icon: t,
  disabled: i,
  onClick: l,
  ...r
}, o) => {
  const a = (s) => {
    i || typeof l == "function" && l(s);
  };
  return /* @__PURE__ */ h(V, {
    component: r.href ? pt : "button",
    ref: o,
    className: go.button,
    type: r.href ? void 0 : "button",
    "aria-disabled": i ? !0 : void 0,
    ...r,
    onClick: a,
    children: [N(t, {
      size: "24"
    }), e]
  });
}), bo = b(({
  label: e,
  ...t
}, i) => /* @__PURE__ */ n(ye, {
  size: "large",
  removeOffset: !0,
  label: e,
  ref: i,
  children: /* @__PURE__ */ n(vo, {
    ...t
  })
}));
bo.displayName = "ButtonIcon";
const yo = "_root_c4mk9_1", wo = {
  root: yo
}, xo = b((e, t) => /* @__PURE__ */ n("span", {
  className: wo.root,
  ref: t,
  ...e
})), Co = "_root_zdz7t_1", No = "_backdrop_zdz7t_11", ko = "_button_zdz7t_19", zo = "_header_zdz7t_43", Do = "_title_zdz7t_56", Ro = "_subtitle_zdz7t_64", So = "_footer_zdz7t_78", Q = {
  root: Co,
  backdrop: No,
  button: ko,
  header: zo,
  "header-content": "_header-content_zdz7t_50",
  title: Do,
  subtitle: Ro,
  "header-actions": "_header-actions_zdz7t_72",
  footer: So,
  "footer-actions": "_footer-actions_zdz7t_85"
}, Io = () => {
  console.error("The primaryAction <Button> component was passed without an onClick handler. Please ensure that the primaryAction onClick handler exists when singleAction is set to true");
}, Eo = ({
  children: e,
  title: t,
  subtitle: i,
  prefix: l,
  singleAction: r = !1,
  headerActions: o,
  primaryAction: a,
  secondaryAction: s,
  tertiaryAction: c
}) => {
  var d, u, _;
  const p = s != null, m = c != null, f = p && m, y = f ? "accent" : "neutral", w = /* @__PURE__ */ h("div", {
    className: Q["footer-actions"],
    style: {
      justifyContent: f ? "space-between" : void 0
    },
    children: [N(a, {
      variant: f ? "transparent" : "solid",
      tone: (d = a.props.tone) != null ? d : "accent",
      size: c ? "md" : "lg"
    }), s ? N(s, {
      variant: "transparent",
      tone: (u = s.props.tone) != null ? u : y,
      size: c ? "md" : "lg"
    }) : null, c ? N(c, {
      variant: "transparent",
      tone: (_ = c.props.tone) != null ? _ : y,
      size: "md"
    }) : null]
  }), C = r ? null : /* @__PURE__ */ h("div", {
    className: Q.footer,
    children: [/* @__PURE__ */ n(te, {}), w]
  });
  return /* @__PURE__ */ h(j, {
    children: [/* @__PURE__ */ h("div", {
      className: Q.header,
      children: [/* @__PURE__ */ h("div", {
        className: Q["header-content"],
        children: [l, /* @__PURE__ */ n("div", {
          className: Q.title,
          children: t
        }), /* @__PURE__ */ n("div", {}), i ? /* @__PURE__ */ n("div", {
          className: Q.subtitle,
          children: i
        }) : null]
      }), o ? /* @__PURE__ */ n("div", {
        className: Q["header-actions"],
        children: o
      }) : null]
    }), /* @__PURE__ */ n("div", {
      className: Q.content,
      children: e
    }), C]
  });
}, Po = b(({
  children: e,
  title: t,
  subtitle: i,
  prefix: l,
  singleAction: r = !1,
  primaryAction: o,
  secondaryAction: a,
  tertiaryAction: s,
  headerActions: c,
  ...d
}, u) => {
  var _;
  const p = {
    children: e,
    title: t,
    subtitle: i,
    prefix: l,
    singleAction: r,
    primaryAction: o,
    secondaryAction: a,
    tertiaryAction: s,
    headerActions: c
  };
  return /* @__PURE__ */ h("div", {
    ref: u,
    className: Q.root,
    ...d,
    children: [r ? /* @__PURE__ */ n("button", {
      className: g(Q.backdrop, r && Q.button),
      type: "button",
      onClick: (_ = o.props.onClick) != null ? _ : Io,
      children: /* @__PURE__ */ n(xo, {
        children: o.props["aria-label"]
      })
    }) : /* @__PURE__ */ n("div", {
      className: Q.backdrop
    }), /* @__PURE__ */ n(Eo, {
      ...p
    })]
  });
});
Po.displayName = "Card";
function Mo(e) {
  var t;
  return e.some((i) => i !== e[0]) ? "mixed" : (t = e[0]) != null ? t : !1;
}
const Lo = "_container_jbsw4_1", To = "_control_jbsw4_10", Ao = "_input_jbsw4_29", Oo = "_icon_jbsw4_38", Fo = "_field_jbsw4_49", $o = "_secondary_jbsw4_157", gn = "_center_jbsw4_161", Ho = b(({
  checked: e,
  onChange: t,
  ...i
}, l) => {
  const r = E(!1), o = E(null), a = l || o, s = e === "mixed", c = e === !0;
  z(() => {
    a && typeof a == "object" && a.current && (a.current.indeterminate = s, r.current = s);
  }, [a, s]);
  const d = (u) => {
    a && typeof a == "object" && a.current && (a.current.indeterminate = r.current), typeof t == "function" && t(u);
  };
  return /* @__PURE__ */ h("div", {
    className: Lo,
    children: [/* @__PURE__ */ n("input", {
      ref: a,
      className: g(Ao, void 0),
      type: "checkbox",
      checked: s ? !1 : e,
      "aria-checked": e,
      onChange: s ? d : t,
      ...i
    }), /* @__PURE__ */ n("div", {
      className: To
    }), /* @__PURE__ */ n("div", {
      className: Oo,
      children: /* @__PURE__ */ h("svg", {
        width: "18",
        height: "18",
        fill: "none",
        viewBox: "0 0 18 18",
        "aria-hidden": !0,
        children: [c ? /* @__PURE__ */ h("g", {
          className: void 0,
          children: [/* @__PURE__ */ n("path", {
            fill: "#000",
            fillOpacity: ".08",
            d: "m7 14.5-4-4 1.415-1.415L7 11.67 13.5 5l1.415 1.415L7 14.5Z"
          }), /* @__PURE__ */ n("path", {
            fill: "#fff",
            d: "m7 13.5-4-4 1.415-1.415L7 10.67 13.5 4l1.415 1.415L7 13.5Z"
          })]
        }) : null, s ? /* @__PURE__ */ h("g", {
          className: void 0,
          children: [/* @__PURE__ */ n("path", {
            fill: "#000",
            fillOpacity: ".08",
            d: "M4 9h10v2H4V9Z"
          }), /* @__PURE__ */ n("path", {
            fill: "#fff",
            d: "M4 8h10v2H4V8Z"
          })]
        }) : null]
      })
    })]
  });
}), ui = b(({
  label: e,
  secondaryLabel: t,
  id: i,
  checked: l = !1,
  ...r
}, o) => {
  const a = Array.isArray(l) ? Mo(l) : l;
  return /* @__PURE__ */ h("div", {
    className: Fo,
    "data-testid": "checkbox",
    "data-checked": a !== !1 ? !0 : void 0,
    "data-disabled": r.disabled ? !0 : void 0,
    "data-invalid": r.required ? !0 : void 0,
    children: [/* @__PURE__ */ n("div", {
      className: gn,
      children: /* @__PURE__ */ n(Ho, {
        ref: o,
        id: i,
        checked: a,
        ...r
      })
    }), e ? /* @__PURE__ */ h(j, {
      children: [/* @__PURE__ */ n(ze, {
        as: "label",
        htmlFor: i,
        tone: r.disabled ? "disabled" : "primary",
        children: e
      }), t ? /* @__PURE__ */ n("div", {
        className: g(gn, $o),
        children: t
      }) : null]
    }) : null]
  });
});
ui.displayName = "Checkbox";
const Zo = "_root_1vuvs_1", Bo = "_solid_1vuvs_10", Vo = "_button_1vuvs_20", jo = "_outlined_1vuvs_36", Go = "_content_1vuvs_84", Wo = "_left_1vuvs_92", qo = "_right_1vuvs_96", Uo = "_icon_1vuvs_101", Ko = "_disclosure_1vuvs_106", Qo = "_small_1vuvs_112", Yo = "_clear_1vuvs_121", Jo = "_medium_1vuvs_130", Xo = "_divider_1vuvs_140", I = {
  root: Zo,
  solid: Bo,
  button: Vo,
  outlined: jo,
  "is-clearable": "_is-clearable_1vuvs_79",
  content: Go,
  left: Wo,
  right: qo,
  icon: Uo,
  disclosure: Ko,
  small: Qo,
  clear: Yo,
  medium: Jo,
  divider: Xo,
  "is-split": "_is-split_1vuvs_180"
}, ea = {
  small: "20",
  medium: "24"
}, ta = b(({
  children: e,
  id: t,
  size: i = "small",
  variant: l = "solid",
  icon: r,
  hasMenu: o,
  onClear: a,
  clearLabel: s,
  ...c
}, d) => {
  const u = Boolean(a), _ = u || o, p = u && o;
  return /* @__PURE__ */ h("div", {
    className: g(I.root, I[l], I[i], p && I["is-split"]),
    id: t,
    children: [/* @__PURE__ */ h("button", {
      className: g(I.button, u && I["is-clearable"]),
      ref: d,
      type: "button",
      ...c,
      children: [/* @__PURE__ */ h("div", {
        className: g(I.content, !r && I.left, !_ && I.right),
        children: [r ? /* @__PURE__ */ n("div", {
          className: I.icon,
          children: N(r, {
            size: ea[i]
          })
        }) : null, /* @__PURE__ */ n(Bt, {
          lines: 1,
          children: e
        }), o ? /* @__PURE__ */ n("div", {
          className: I.disclosure,
          children: /* @__PURE__ */ n(ni, {
            direction: "down",
            size: "20"
          })
        }) : null]
      }), p ? /* @__PURE__ */ n("div", {
        className: I.divider
      }) : null]
    }), u ? /* @__PURE__ */ n("button", {
      className: I.clear,
      type: "button",
      onClick: a,
      "aria-label": s,
      children: /* @__PURE__ */ n(ht, {
        size: "24"
      })
    }) : null]
  });
});
ta.displayName = "Chip";
const na = "_indicator_j4wbs_5", Ut = {
  "chip-outline": "_chip-outline_j4wbs_1",
  indicator: na,
  "no-options": "_no-options_j4wbs_22"
};
function ia({
  innerProps: e
}) {
  return /* @__PURE__ */ n("div", {
    ...e,
    className: Ut.indicator,
    children: /* @__PURE__ */ n(ht, {
      size: "24"
    })
  });
}
function la({
  children: e
}) {
  return /* @__PURE__ */ n("div", {
    className: g(I.root, I.solid, I.medium, I["is-split"]),
    children: /* @__PURE__ */ n("div", {
      className: g(I.button, I["is-clearable"]),
      children: e
    })
  });
}
function ra({
  children: e,
  ...t
}) {
  const {
    icon: i
  } = t.data;
  return /* @__PURE__ */ h("div", {
    className: g(I.content, !i && I.left),
    children: [i ? /* @__PURE__ */ n("div", {
      className: I.icon,
      children: N(i, {
        size: 24
      })
    }) : null, e]
  });
}
function oa({
  ...e
}) {
  const t = {
    ...e,
    innerProps: {
      ...e.innerProps,
      className: I.clear
    }
  };
  return /* @__PURE__ */ n(ut.MultiValueRemove, {
    ...t,
    children: /* @__PURE__ */ n(ht, {
      size: "24"
    })
  });
}
function aa({
  ...e
}) {
  return /* @__PURE__ */ n(ut.MultiValue, {
    ...e,
    components: {
      Container: la,
      Label: ra,
      Remove: oa
    }
  });
}
function sa({
  innerProps: e
}) {
  return /* @__PURE__ */ n("div", {
    ...e,
    className: Ut.indicator,
    children: /* @__PURE__ */ n(ee, {
      size: "24"
    })
  });
}
function ca({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ n(Wt, {
    ...t,
    children: e
  });
}
function da({
  children: e
}) {
  return /* @__PURE__ */ n("div", {
    className: Ut["no-options"],
    children: e
  });
}
function ua({
  isSelected: e,
  icon: t,
  isMultiline: i
}) {
  const l = i ? "32" : "24";
  return e ? /* @__PURE__ */ n("div", {
    className: M.icon,
    style: {
      color: "var(--i-blue-500)"
    },
    children: /* @__PURE__ */ n(ei, {
      size: l
    })
  }) : t ? /* @__PURE__ */ n("div", {
    className: M.icon,
    children: N(t, {
      size: l
    })
  }) : /* @__PURE__ */ n("div", {
    style: {
      height: `${l}px`,
      width: `${l}px`,
      flex: "none"
    }
  });
}
function ha({
  ...e
}) {
  const {
    description: t,
    icon: i,
    label: l
  } = e.data, r = Boolean(t), o = {
    ...e,
    innerProps: {
      ...e.innerProps,
      className: g(M.item, r && M.multiline)
    }
  }, a = /* @__PURE__ */ n(ji, {
    searchWords: [e.selectProps.inputValue],
    textToHighlight: l,
    autoEscape: !0
  }), s = r ? /* @__PURE__ */ h("div", {
    className: M.content,
    children: [/* @__PURE__ */ n("div", {
      className: M.text,
      children: a
    }), /* @__PURE__ */ n("div", {
      className: M.description,
      children: t
    })]
  }) : /* @__PURE__ */ n("div", {
    className: M.text,
    children: a
  });
  return /* @__PURE__ */ h(ut.Option, {
    ...o,
    children: [/* @__PURE__ */ n(ua, {
      isSelected: e.isSelected,
      isMulti: e.isMulti,
      icon: i,
      isMultiline: r
    }), s]
  });
}
function _a({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ n(ut.MenuPortal, {
    ...t,
    children: /* @__PURE__ */ n("div", {
      "data-combobox-portal": !0,
      children: e
    })
  });
}
function pa({
  allowCustom: e,
  showDropdownIndicator: t,
  disableFloatingMenu: i,
  isMultiNoChips: l,
  __privateNonFloatingMenu: r,
  ...o
}) {
  const a = H((c) => i || l ? {
    position: "relative"
  } : {
    ...c,
    position: r ? "relative" : c.position,
    zIndex: "var(--i-z-dialog)",
    marginTop: "4px",
    marginBottom: "4px",
    border: "1px solid var(--i-text-borders)",
    overflow: "hidden",
    borderRadius: "6px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.06)"
  }, [r, i, l]), s = {
    menuPortalTarget: i || l ? o.menuPortalTarget : document.body,
    menuIsOpen: i || l,
    ...o,
    ...l ? {
      isMulti: !0,
      controlShouldRenderValue: !1,
      hideSelectedOptions: !1,
      backspaceRemovesValue: !1
    } : {},
    tabSelectsValue: !1,
    components: {
      ClearIndicator: ia,
      DropdownIndicator: t ? sa : null,
      GroupHeading: ca,
      IndicatorSeparator: null,
      MultiValue: aa,
      NoOptionsMessage: da,
      Option: ha,
      MenuPortal: _a
    },
    noOptionsMessage: () => "No option available.",
    styles: {
      control: (c, d) => ({
        ...c,
        borderRadius: "8px",
        border: 0,
        boxShadow: d.isFocused ? "0 0 0 2px rgba(2, 128, 255, 0.24), inset 0 0 0 1px var(--i-blue-500)" : "inset 0 0 0 1px var(--i-gray-500)",
        paddingLeft: "8px",
        margin: i || l ? "0 var(--i-space-150)" : void 0
      }),
      valueContainer: (c) => ({
        ...c,
        gap: "4px",
        padding: "4px"
      }),
      singleValue: (c) => ({
        ...c,
        paddingLeft: "8px",
        marginLeft: 0
      }),
      placeholder: (c) => ({
        ...c,
        paddingLeft: "8px",
        marginLeft: 0
      }),
      indicatorsContainer: (c) => ({
        ...c,
        gap: "8px",
        padding: "8px",
        height: "40px"
      }),
      input: (c, d) => ({
        ...c,
        margin: 0,
        paddingLeft: d.isMulti ? void 0 : "8px",
        ":is(:first-child)": {
          paddingLeft: "8px"
        },
        "div[id] ~ &": {
          paddingLeft: "8px"
        }
      }),
      menu: a,
      menuList: (c) => ({
        ...c,
        paddingTop: "12px",
        paddingBottom: "12px"
      }),
      menuPortal: (c) => ({
        ...c,
        zIndex: "var(--i-z-dialog)"
      }),
      multiValue: (c, {
        isFocused: d
      }) => ({
        ...c,
        boxShadow: d ? "inset 0 0 0 1px var(--i-blue-500)" : void 0
      }),
      group: (c) => ({
        ...c,
        padding: 0
      }),
      option: (c, d) => ({
        ...c,
        display: "flex",
        padding: "0.5rem",
        color: "var(--i-text-primary)",
        backgroundColor: d.isFocused ? "var(--i-gray-100)" : "transparent"
      })
    }
  };
  return "loadOptions" in o ? /* @__PURE__ */ n(Wi, {
    cacheOptions: !0,
    defaultOptions: !0,
    ...s
  }) : e ? /* @__PURE__ */ n(qi, {
    ...s
  }) : /* @__PURE__ */ n(Gi, {
    ...s
  });
}
const ma = "_root_1ylb9_1", fa = "_label_1ylb9_7", ga = "_primary_1ylb9_14", va = "_secondary_1ylb9_19", ba = "_tertiary_1ylb9_24", He = {
  root: ma,
  label: fa,
  primary: ga,
  secondary: va,
  tertiary: ba
};
function ya({
  id: e,
  htmlFor: t,
  label: i,
  secondaryLabel: l,
  tertiaryLabel: r
}) {
  if (i == null)
    return null;
  const o = /* @__PURE__ */ h("span", {
    className: He.label,
    children: [/* @__PURE__ */ n("span", {
      className: He.primary,
      children: i
    }), l ? /* @__PURE__ */ n("span", {
      className: He.secondary,
      children: l
    }) : null]
  });
  return /* @__PURE__ */ h("span", {
    className: He.root,
    children: [/* @__PURE__ */ n("label", {
      id: e,
      htmlFor: t,
      children: o
    }), r ? /* @__PURE__ */ n("span", {
      className: He.tertiary,
      children: r
    }) : null]
  });
}
const wa = "_root_123r7_1", xa = "_message_123r7_7", Ca = "_neutral_123r7_14", Na = "_positive_123r7_18", ka = "_caution_123r7_22", za = "_critical_123r7_26", Da = "_secondary_123r7_30", Ke = {
  root: wa,
  message: xa,
  neutral: Ca,
  positive: Na,
  caution: ka,
  critical: za,
  secondary: Da
};
function Ra({
  id: e,
  message: t,
  tone: i = "neutral",
  secondaryMessage: l
}) {
  return /* @__PURE__ */ h("div", {
    className: Ke.root,
    id: e,
    children: [/* @__PURE__ */ n("div", {
      className: g(Ke.message, Ke[i]),
      children: t
    }), l ? /* @__PURE__ */ n("div", {
      className: Ke.secondary,
      children: l
    }) : null]
  });
}
const Sa = "_field_yqdeg_1", Ia = "_wrapper_yqdeg_8", Ea = "_input_yqdeg_12", Pa = "_critical_yqdeg_51", Ma = "_unstyled_yqdeg_73", La = "_icon_yqdeg_80", Ce = {
  field: Sa,
  wrapper: Ia,
  input: Ea,
  critical: Pa,
  "has-icon": "_has-icon_yqdeg_69",
  unstyled: Ma,
  icon: La
};
function gt({
  id: e,
  name: t,
  disabled: i,
  autoComplete: l,
  autoFocus: r,
  required: o,
  children: a,
  tone: s = "neutral",
  icon: c,
  label: d,
  secondaryLabel: u,
  tertiaryLabel: _,
  message: p,
  secondaryMessage: m,
  "aria-describedby": f,
  unstyled: y = !1,
  ...w
}) {
  const C = `${e}-label`, v = `${e}-message`;
  return /* @__PURE__ */ h("div", {
    className: Ce.field,
    children: [d ? /* @__PURE__ */ n(ya, {
      id: C,
      htmlFor: e,
      label: d,
      secondaryLabel: u,
      tertiaryLabel: _
    }) : null, /* @__PURE__ */ n("div", {
      className: Ce.wrapper,
      children: a({
        "aria-labelledby": C,
        ...w,
        id: e,
        name: t,
        disabled: i,
        autoComplete: l,
        autoFocus: r,
        "aria-describedby": p || m ? v : void 0,
        "aria-required": o,
        className: g(Ce.input, Ce[s], y ? Ce.unstyled : null, c ? Ce["has-icon"] : null)
      }, c ? /* @__PURE__ */ n("div", {
        className: Ce.icon,
        children: N(c, {
          size: 20
        })
      }) : null)
    }), p || m ? /* @__PURE__ */ n(Ra, {
      id: v,
      tone: s,
      message: p,
      secondaryMessage: m
    }) : null]
  });
}
const Ta = "_input_nrin1_1", Aa = "_segment_nrin1_26", Nt = {
  input: Ta,
  "is-readonly": "_is-readonly_nrin1_7",
  segment: Aa
};
function Ze(e) {
  return e && Ui(e.toISOString().split("T")[0]);
}
b(({
  value: e,
  defaultValue: t,
  minValue: i,
  maxValue: l,
  placeholderValue: r,
  onChange: o,
  disabled: a,
  readOnly: s,
  ...c
}, d) => {
  const u = (_) => {
    o == null || o(_.toDate("UTC"));
  };
  return /* @__PURE__ */ n(gt, {
    ...c,
    children: ({
      className: _,
      ...p
    }) => /* @__PURE__ */ n(Ki, {
      ref: d,
      ...p,
      value: Ze(e),
      defaultValue: Ze(t),
      minValue: Ze(i),
      maxValue: Ze(l),
      placeholderValue: Ze(r),
      onChange: u,
      isDisabled: a,
      isReadOnly: s,
      children: /* @__PURE__ */ n(Qi, {
        className: g(_, Nt.input, s && Nt["is-readonly"]),
        children: (m) => /* @__PURE__ */ n(Yi, {
          segment: m,
          className: Nt.segment
        })
      })
    })
  });
});
const Oa = [{
  displayValue: "S",
  value: "Sunday"
}, {
  displayValue: "M",
  value: "Monday"
}, {
  displayValue: "T",
  value: "Tuesday"
}, {
  displayValue: "W",
  value: "Wednesday"
}, {
  displayValue: "T",
  value: "Thursday"
}, {
  displayValue: "F",
  value: "Friday"
}, {
  displayValue: "S",
  value: "Saturday"
}], Fa = (e) => {
  const t = new Date(e.getFullYear(), e.getMonth(), 1), i = Ji(t), l = on(t), r = Xe(t, {
    months: 1
  }), o = on(r), a = Array(6 * 7).fill(null).map((d, u) => {
    if (u < i)
      return {
        disabled: !0,
        value: Xe(t, {
          days: i - u
        }),
        displayValue: o - i + u + 1
      };
    const _ = u - i;
    return {
      disabled: _ >= l,
      value: pe(t, {
        days: _
      }),
      displayValue: _ % l + 1
    };
  }), s = Array(6).fill(null).map(() => Array(7).fill(null));
  let c = 0;
  return s.forEach((d, u) => {
    d.forEach((_, p) => {
      s[u][p] = a[c], c += 1;
    });
  }), s;
}, $a = "_cell_1azf4_1", Ha = "_selected_1azf4_11", Za = "_disabled_1azf4_27", Ba = "_button_1azf4_31", Ne = {
  cell: $a,
  "hovered-range": "_hovered-range_1azf4_7",
  "selected-range": "_selected-range_1azf4_11",
  selected: Ha,
  disabled: Za,
  button: Ba,
  "quarter-view": "_quarter-view_1azf4_46"
};
function vn(e, t, i) {
  return !t || !i || Yn(i, t) ? !1 : Jn(e, {
    start: t,
    end: i
  });
}
const Va = ({
  datePicker: e,
  variant: t,
  day: i
}) => {
  const {
    state: {
      selectedDate: l,
      selectedDateRangeStart: r,
      selectedDateRangeEnd: o,
      hoveredDate: a
    }
  } = e, s = r && bt(r, i.value), c = o && bt(o, i.value), d = l != null ? bt(l, i.value) : Boolean(s || c), u = r != null && o != null, _ = vn(i.value, r, a) && !u, p = vn(i.value, r, o);
  return /* @__PURE__ */ n("td", {
    onMouseEnter: () => {
      i.disabled || e.setHoveredDate(i.value);
    },
    onMouseLeave: () => {
      i.disabled || e.setHoveredDate(void 0);
    },
    className: g(Ne.cell, i.disabled && Ne.disabled, _ && Ne["hovered-range"], p && Ne["selected-range"], d && Ne.selected),
    children: /* @__PURE__ */ n("button", {
      type: "button",
      disabled: i.disabled,
      onClick: () => {
        e.selectDate(i.value);
      },
      className: g(Ne.button, t === "quarter" && Ne["quarter-view"]),
      "aria-pressed": d,
      "aria-label": de(i.value, "PPPP"),
      children: i.displayValue
    })
  }, i.value.toDateString());
}, ja = "_calendar_1wvmt_5", Ga = "_weekday_1wvmt_11", bn = {
  calendar: ja,
  weekday: Ga
}, kt = b(({
  variant: e,
  datePicker: t,
  month: i
}, l) => {
  const r = Fa(i);
  return /* @__PURE__ */ h("table", {
    ref: l,
    role: "grid",
    className: bn.calendar,
    children: [/* @__PURE__ */ n("thead", {
      children: /* @__PURE__ */ n("tr", {
        children: Oa.map(({
          displayValue: o,
          value: a
        }) => /* @__PURE__ */ n("th", {
          scope: "col",
          "aria-label": a,
          abbr: a,
          children: /* @__PURE__ */ n(ye, {
            label: a,
            children: /* @__PURE__ */ n("span", {
              className: bn.weekday,
              children: o
            })
          })
        }, a))
      })
    }), /* @__PURE__ */ n("tbody", {
      children: r.map((o) => /* @__PURE__ */ n("tr", {
        children: o.map((a) => /* @__PURE__ */ n(Va, {
          variant: e,
          day: a,
          datePicker: t
        }, a.value.toDateString()))
      }, o.map(({
        value: a
      }) => a.toDateString()).join("_")))
    })]
  });
}), Wa = "_footer_1dwu7_1", qa = {
  footer: Wa
}, Ua = ({
  isMonthPickerOpen: e,
  primaryFooterActionLabel: t,
  secondaryFooterActionLabel: i,
  primaryFooterAction: l,
  secondaryFooterAction: r
}) => /* @__PURE__ */ h("div", {
  className: qa.footer,
  children: [r ? /* @__PURE__ */ n(he, {
    disabled: e,
    size: "sm",
    variant: "muted",
    onClick: r,
    children: i
  }) : null, l ? /* @__PURE__ */ n(he, {
    disabled: e,
    size: "sm",
    tone: "accent",
    variant: "solid",
    onClick: l,
    children: t
  }) : null]
}), Ka = "_header_i9y6e_1", Qa = "_month_i9y6e_8", Ya = "_text_i9y6e_21", Ja = "_first_i9y6e_26", Xa = "_last_i9y6e_30", _e = {
  header: Ka,
  month: Qa,
  text: Ya,
  first: Ja,
  last: Xa
}, es = ({
  variant: e,
  selectedMonth: t,
  isMonthPickerOpen: i,
  onPrevMonthClick: l,
  onNextMonthClick: r,
  onToggleMonthPicker: o
}) => /* @__PURE__ */ h("div", {
  className: _e.header,
  children: [/* @__PURE__ */ n(G, {
    label: `Previous ${e === "month" ? "Month" : "Quarter"}`,
    onClick: l,
    icon: /* @__PURE__ */ n(ee, {
      direction: "left"
    })
  }), /* @__PURE__ */ n("div", {
    className: g(_e.month, e === "quarter" && _e.first),
    children: e === "quarter" ? /* @__PURE__ */ n("span", {
      className: _e.text,
      children: de(t, "LLLL yyy")
    }) : /* @__PURE__ */ n(he, {
      size: "md",
      variant: "transparent",
      suffix: /* @__PURE__ */ n(ni, {
        size: "16",
        direction: "down"
      }),
      onClick: o,
      "aria-haspopup": !0,
      "aria-expanded": i,
      children: de(t, "LLLL yyy")
    })
  }), e === "quarter" ? /* @__PURE__ */ n("div", {
    className: _e.month,
    children: /* @__PURE__ */ n("span", {
      className: _e.text,
      children: de(pe(t, {
        months: 1
      }), "LLLL yyy")
    })
  }) : null, e === "quarter" ? /* @__PURE__ */ n("div", {
    className: g(_e.month, _e.last),
    children: /* @__PURE__ */ n("span", {
      className: _e.text,
      children: de(pe(t, {
        months: 2
      }), "LLLL yyy")
    })
  }) : null, /* @__PURE__ */ n(G, {
    label: `Next ${e === "month" ? "Month" : "Quarter"}`,
    onClick: r,
    icon: /* @__PURE__ */ n(ee, {
      direction: "right"
    })
  })]
}), ts = (e) => {
  const [t, i] = k({
    height: e.initialHeight,
    width: e.initialWidth
  }), l = E(null);
  return z(() => {
    l.current && i({
      height: l.current.clientHeight,
      width: l.current.clientWidth - 4
    });
  }, []), {
    ref: l,
    size: t
  };
}, ns = (e) => {
  var t, i;
  const {
    value: l,
    firstDayOfFirstQuarter: r,
    initialDisplayedMonth: o,
    dateRangePicker: a,
    onSelect: s
  } = e, c = (C) => C != null && "startDate" in C, d = c(l) ? void 0 : l, u = c(l) ? l : void 0, [_, p] = k(), [m, f] = k((i = (t = o != null ? o : d) != null ? t : u == null ? void 0 : u.startDate) != null ? i : new Date()), y = (C) => {
    if (((v) => a)()) {
      const {
        startDate: v,
        endDate: x
      } = u != null ? u : {
        startDate: void 0,
        endDate: void 0
      }, D = v == null, L = v != null && x != null;
      D || L || Yn(C, v) ? s({
        startDate: C,
        endDate: void 0
      }) : s({
        startDate: v,
        endDate: C
      });
      return;
    }
    s(C);
  }, w = () => {
    const C = new Date(m.getFullYear(), r.getMonth(), r.getDate());
    return [-4, -3, -2, -1, 0, 1, 2, 3].map((v) => ({
      startDate: pe(C, {
        months: 3 * v
      }),
      endDate: pe(C, {
        months: 3 * (v + 1),
        days: -1
      })
    })).findIndex(({
      startDate: v,
      endDate: x
    }) => Jn(m, {
      start: v,
      end: x
    })) % 4 + 1;
  };
  return {
    state: {
      selectedMonth: m,
      hoveredDate: _,
      selectedDate: d,
      selectedDateRangeStart: u == null ? void 0 : u.startDate,
      selectedDateRangeEnd: u == null ? void 0 : u.endDate
    },
    config: {
      dateRangePicker: e.dateRangePicker,
      firstDayOfFirstQuarter: e.firstDayOfFirstQuarter,
      initialDisplayedMonth: e.initialDisplayedMonth
    },
    jumpToMonth: f,
    setHoveredDate: p,
    getDisplayedQuarter: w,
    selectDate: y
  };
};
function is({
  initialIndex: e,
  numOfItemsToLoad: t = 20,
  loadItems: i,
  body: l,
  ...r
}) {
  const [o, a] = k(e), [s, c] = k(i(e, t)), d = H(() => {
    const _ = o - t;
    a(() => _), c(() => [...i(_, t), ...s]);
  }, [t, o, s, i, c]), u = H(() => {
    c((_) => [..._, ...i(e + _.length, t)]);
  }, [e, t, i]);
  return /* @__PURE__ */ n(el, {
    ...r,
    "data-testid": "virtuoso-scroller",
    firstItemIndex: o,
    data: s,
    startReached: d,
    endReached: u,
    itemContent: l
  });
}
const ls = "_wrapper_mufee_1", rs = "_calendar_mufee_6", os = "_caption_mufee_12", as = "_cell_mufee_19", ss = "_selected_mufee_30", cs = "_button_mufee_36", Pe = {
  wrapper: ls,
  calendar: rs,
  caption: os,
  cell: as,
  selected: ss,
  button: cs
}, ds = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]];
function us(e, t) {
  return Array(t).fill(0).map((i, l) => ({
    value: e + l,
    date: new Date(e + l, 0, 0)
  }));
}
const hs = ({
  datePicker: e,
  onMonthSelect: t,
  ...i
}) => {
  const {
    state: l
  } = e;
  return /* @__PURE__ */ n(is, {
    ...i,
    initialIndex: new Date().getFullYear(),
    loadItems: us,
    body: (r, o) => /* @__PURE__ */ n("div", {
      className: Pe.wrapper,
      children: /* @__PURE__ */ h("table", {
        role: "grid",
        className: Pe.calendar,
        children: [/* @__PURE__ */ n("caption", {
          className: Pe.caption,
          children: o.value
        }), /* @__PURE__ */ n("tbody", {
          children: ds.map((a, s) => /* @__PURE__ */ n("tr", {
            style: {
              display: "flex",
              gap: "4px"
            },
            children: a.map((c) => {
              const d = new Date(o.value, c), u = l.selectedDateRangeStart && an(d, l.selectedDateRangeStart), _ = l.selectedDate && an(d, l.selectedDate), p = u != null ? u : _;
              return /* @__PURE__ */ n("td", {
                className: g(Pe.cell, p && Pe.selected),
                children: /* @__PURE__ */ n("button", {
                  className: Pe.button,
                  type: "button",
                  "aria-label": de(d, "MMMM YYY"),
                  onClick: () => {
                    t(d);
                  },
                  children: de(d, "MMM")
                })
              }, c);
            })
          }, `${o.value + s}`))
        })]
      })
    }, r)
  });
}, _s = "_root_v3l1v_1", ps = "_sm_v3l1v_54", ms = "_contents_v3l1v_57", fs = "_md_v3l1v_62", gs = "_lg_v3l1v_71", vs = "_text_v3l1v_84", bs = "_prefix_v3l1v_88", ys = "_suffix_v3l1v_93", Me = {
  root: _s,
  sm: ps,
  contents: ms,
  md: fs,
  lg: gs,
  text: vs,
  prefix: bs,
  suffix: ys
}, ws = b(({
  children: e,
  size: t = "md",
  prefix: i,
  suffix: l = /* @__PURE__ */ n(ee, {}),
  disabled: r,
  fullWidth: o,
  onClick: a,
  ...s
}, c) => {
  const d = (u) => {
    r || typeof a == "function" && a(u);
  };
  return /* @__PURE__ */ n("button", {
    ref: c,
    className: g(Me.root, Me[t], o && O.full),
    type: "button",
    "aria-disabled": r ? !0 : void 0,
    ...s,
    onClick: d,
    children: /* @__PURE__ */ h("span", {
      className: g(O.contents, Me.contents),
      children: [i ? /* @__PURE__ */ n("div", {
        className: Me.suffix,
        children: N(i, {
          size: ve[t]
        })
      }) : null, /* @__PURE__ */ n("span", {
        className: g(O.text, Me.text),
        children: e
      }), l ? /* @__PURE__ */ n("div", {
        className: Me.suffix,
        children: N(l, {
          size: ve[t]
        })
      }) : null]
    })
  });
}), [xs, hi] = De({
  strict: !1,
  name: "PopoverContext"
});
function Cs({
  children: e,
  open: t,
  defaultOpen: i,
  onOpenChange: l,
  placement: r = "bottom",
  verticalOffset: o = 4,
  dimBackdrop: a = !1,
  portalRoot: s
}) {
  const [c, d] = _t({
    prop: t,
    defaultProp: i,
    onChange: l
  }), u = Zt(), _ = `${u}-label`, p = `${u}-description`, {
    x: m,
    y: f,
    reference: y,
    floating: w,
    strategy: C,
    context: v
  } = nt({
    open: c,
    onOpenChange: d,
    middleware: [it(o), lt(), rt({
      padding: 4
    })],
    placement: r,
    whileElementsMounted: ot
  }), {
    getReferenceProps: x,
    getFloatingProps: D
  } = at([qn(v), st(v), ct(v)]), L = x({
    ref: y
  }), T = D({
    ref: w,
    style: {
      position: C,
      top: f != null ? f : 0,
      left: m != null ? m : 0
    },
    "aria-labelledby": _,
    "aria-describedby": p
  });
  return /* @__PURE__ */ n(xs, {
    value: {
      open: c,
      setOpen: d,
      referenceProps: L,
      floatingProps: T,
      floatingContext: v,
      labelId: _,
      descriptionId: p,
      dimBackdrop: a,
      portalRoot: s
    },
    children: e
  });
}
const _i = b(({
  children: e,
  ...t
}, i) => {
  const l = hi(), {
    ref: r,
    onClick: o,
    ...a
  } = l.referenceProps, s = Vt(i, r), c = {
    ...a,
    ref: s,
    onClick: mt(t.onClick, o)
  };
  return e(c);
});
_i.displayName = "PopoverTrigger";
function Ns({
  children: e,
  constrained: t = !1,
  minHeight: i = 0,
  maxHeight: l = 9999
}) {
  const r = hi(), {
    style: o,
    ...a
  } = r.floatingProps;
  return r.open ? /* @__PURE__ */ n(We, {
    root: r.portalRoot,
    children: /* @__PURE__ */ h(j, {
      children: [r.dimBackdrop ? /* @__PURE__ */ n(Un, {
        className: xt.backdrop
      }) : null, /* @__PURE__ */ n(dt, {
        context: r.floatingContext,
        order: ["floating", "content"],
        children: /* @__PURE__ */ n("div", {
          onClick: (s) => s.stopPropagation(),
          className: g(xt.popover, t && xt.constrained),
          style: {
            "--ic-popover-floating-top": `${o.top}px`,
            "--ic-popover-min-height": `${i}px`,
            "--ic-popover-max-height": `${l}px`,
            ...o
          },
          ...a,
          children: e({
            labelId: r.labelId,
            descriptionId: r.descriptionId,
            close: () => {
              r.setOpen(!1);
            }
          })
        })
      })]
    })
  }) : null;
}
const ks = "_menu_speml_1", zs = "_heading_speml_6", Ds = "_actions_speml_10", zt = {
  menu: ks,
  heading: zs,
  actions: Ds
}, yn = ({
  children: e,
  ...t
}) => {
  const i = E(null);
  return z(() => {
    const l = i.current;
    if (!l)
      return;
    function r() {
      !l || l.focus();
    }
    function o() {
      !l || l.focus();
    }
    return l.addEventListener("mouseenter", r), l.addEventListener("mouseleave", o), () => {
      l.removeEventListener("mouseenter", r), l.removeEventListener("mouseLeave", o);
    };
  }, []), /* @__PURE__ */ n(ae, {
    ref: i,
    ...t,
    children: e
  });
}, Rs = ({
  datePicker: e,
  customQuarterPickerActions: t = []
}) => {
  const i = e.state.selectedMonth, l = new Date(i.getFullYear(), e.config.firstDayOfFirstQuarter.getMonth(), e.config.firstDayOfFirstQuarter.getDate()), r = (a, s) => `Q${s} FY${sn(a)}`, o = Array(4).fill(0).map((a, s) => ({
    name: r(i, s + 1),
    date: Xi(l, s)
  }));
  return /* @__PURE__ */ h(Cs, {
    placement: "bottom-start",
    children: [/* @__PURE__ */ n(_i, {
      children: (a) => /* @__PURE__ */ n("div", {
        style: {
          minWidth: 100
        },
        children: /* @__PURE__ */ n(ws, {
          ...a,
          size: "sm",
          fullWidth: !0,
          children: r(i, e.getDisplayedQuarter())
        })
      })
    }), /* @__PURE__ */ n(Ns, {
      children: ({
        close: a
      }) => /* @__PURE__ */ h("div", {
        children: [/* @__PURE__ */ h("div", {
          className: zt.menu,
          children: [/* @__PURE__ */ n("div", {
            className: zt.heading,
            children: /* @__PURE__ */ h(Wt, {
              children: ["FY ", sn(i)]
            })
          }), /* @__PURE__ */ h("div", {
            className: zt.actions,
            children: [/* @__PURE__ */ n(G, {
              round: !0,
              label: "Prev",
              icon: /* @__PURE__ */ n(ee, {
                size: "20",
                direction: "left"
              }),
              onClick: () => {
                e.jumpToMonth(Xe(i, {
                  years: 1
                }));
              }
            }), /* @__PURE__ */ n(G, {
              round: !0,
              label: "Next",
              icon: /* @__PURE__ */ n(ee, {
                size: "20",
                direction: "right"
              }),
              onClick: () => {
                e.jumpToMonth(pe(i, {
                  years: 1
                }));
              }
            })]
          })]
        }), o.map(({
          date: s,
          name: c
        }) => /* @__PURE__ */ n(yn, {
          "aria-label": c,
          onClick: () => {
            e.jumpToMonth(s), a();
          },
          children: c
        }, c)), t.length > 0 ? /* @__PURE__ */ n(ci, {}) : null, t.map(({
          text: s,
          onClick: c
        }) => /* @__PURE__ */ n(yn, {
          onClick: () => {
            c(e), a();
          },
          children: s
        }, s))]
      })
    })]
  });
}, Ss = "_toolbar_1y2tz_1", Is = "_info_1y2tz_9", Es = "_actions_1y2tz_15", Qe = {
  toolbar: Ss,
  info: Is,
  actions: Es,
  "quarter-picker": "_quarter-picker_1y2tz_23"
}, Ps = ({
  toolbar: e,
  datePicker: t,
  variant: i,
  dateRangePicker: l
}) => {
  var r;
  if (!e)
    return null;
  const {
    showQuarterPicker: o
  } = e, {
    state: a
  } = t, {
    selectedDate: s
  } = a, c = {
    startDate: a.selectedDateRangeStart,
    endDate: a.selectedDateRangeEnd
  }, d = c.startDate && c.endDate ? `${de(c.startDate, "PP")} - ${de(c.endDate, "PP")}` : "Select a date range below", u = s ? de(s, "PP") : "Select a date below", _ = (r = e.actions) != null ? r : [];
  return /* @__PURE__ */ h("div", {
    className: Qe.toolbar,
    children: [/* @__PURE__ */ n("span", {
      className: Qe.info,
      children: l === !0 ? d : u
    }), /* @__PURE__ */ h("div", {
      className: Qe.actions,
      children: [i === "quarter" && o ? /* @__PURE__ */ n("div", {
        className: Qe["quarter-picker"],
        children: /* @__PURE__ */ n(Rs, {
          datePicker: t,
          customQuarterPickerActions: e.customQuarterPickerActions
        })
      }) : null, _.map(({
        label: p,
        icon: m,
        onClick: f
      }) => /* @__PURE__ */ n(G, {
        round: !0,
        label: p,
        icon: m,
        onClick: () => {
          f(t);
        }
      }, p))]
    }), e.showJumpToTodayButton && /* @__PURE__ */ h(j, {
      children: [/* @__PURE__ */ n(te, {
        vertical: !0
      }), /* @__PURE__ */ n(he, {
        onClick: () => t.jumpToMonth(new Date()),
        size: "sm",
        tone: "accent",
        variant: "transparent",
        children: "Today"
      })]
    })]
  });
}, Ms = "_wrapper_1te6f_1", Ls = "_calendars_1te6f_8", Ts = "_section_1te6f_15", As = "_quarter_1te6f_20", Os = "_month_1te6f_25", et = {
  wrapper: Ms,
  calendars: Ls,
  section: Ts,
  quarter: As,
  month: Os
};
function wn({
  value: e,
  toolbar: t,
  initialDisplayedMonth: i,
  firstDayOfFirstQuarter: l = new Date(0, 0, 1),
  variant: r = "month",
  dateRangePicker: o = !1,
  primaryFooterActionLabel: a = "Save",
  secondaryFooterActionLabel: s = "Cancel",
  onChange: c,
  primaryFooterAction: d,
  secondaryFooterAction: u
}) {
  const _ = ns({
    firstDayOfFirstQuarter: l,
    dateRangePicker: o,
    value: e,
    initialDisplayedMonth: i,
    onSelect: c
  }), {
    state: p,
    jumpToMonth: m
  } = _, {
    selectedMonth: f
  } = p, [y, w] = k(!1), {
    ref: C,
    size: v
  } = ts({
    initialHeight: 230,
    initialWidth: 304
  }), x = f, D = pe(f, {
    months: 1
  }), L = pe(f, {
    months: 2
  });
  return /* @__PURE__ */ h("div", {
    className: et.wrapper,
    children: [t != null ? /* @__PURE__ */ h(j, {
      children: [/* @__PURE__ */ n(Be, {
        variant: r,
        children: /* @__PURE__ */ n(Ps, {
          datePicker: _,
          toolbar: t,
          dateRangePicker: o,
          variant: r
        })
      }), /* @__PURE__ */ n(te, {})]
    }) : null, /* @__PURE__ */ n(Be, {
      variant: r,
      children: /* @__PURE__ */ n(es, {
        variant: r,
        selectedMonth: f,
        isMonthPickerOpen: y,
        onToggleMonthPicker: () => w((T) => !T),
        onPrevMonthClick: () => {
          m(Xe(f, {
            months: r === "month" ? 1 : 3
          }));
        },
        onNextMonthClick: () => {
          m(pe(f, {
            months: r === "month" ? 1 : 3
          }));
        }
      })
    }), /* @__PURE__ */ n(te, {}), y && r === "month" && /* @__PURE__ */ n(Be, {
      variant: r,
      children: /* @__PURE__ */ n(hs, {
        datePicker: _,
        onMonthSelect: (T) => {
          m(T), w(!1);
        },
        style: {
          minWidth: v.width + 24,
          minHeight: v.height
        }
      })
    }), /* @__PURE__ */ n(Be, {
      variant: r,
      children: /* @__PURE__ */ h("div", {
        className: et.calendars,
        children: [(!y || r === "quarter") && /* @__PURE__ */ n(kt, {
          datePicker: _,
          ref: C,
          variant: r,
          month: x
        }), r === "quarter" && /* @__PURE__ */ n(kt, {
          datePicker: _,
          variant: r,
          month: D
        }), r === "quarter" && /* @__PURE__ */ n(kt, {
          datePicker: _,
          variant: r,
          month: L
        })]
      })
    }), d != null ? /* @__PURE__ */ h(j, {
      children: [/* @__PURE__ */ n(te, {}), /* @__PURE__ */ n(Be, {
        variant: r,
        children: /* @__PURE__ */ n(Ua, {
          isMonthPickerOpen: y,
          primaryFooterActionLabel: a,
          secondaryFooterActionLabel: s,
          primaryFooterAction: d,
          secondaryFooterAction: u
        })
      })]
    }) : null]
  });
}
function Be({
  variant: e,
  children: t
}) {
  return /* @__PURE__ */ n("div", {
    className: g(et.section, e && et[e]),
    children: t
  });
}
const Fs = "_root_1edxm_1", Dt = {
  root: Fs
};
function Kt({
  children: e,
  as: t = "div",
  space: i = "none",
  dividers: l,
  align: r,
  ...o
}) {
  const a = Qn(e), s = t === "ol" || t === "ul" ? "li" : "div", c = {
    "--ic-stack-gap": `var(--i-space-${i})`,
    "--ic-stack-align": r
  };
  return /* @__PURE__ */ n(V, {
    component: t,
    className: Dt.root,
    style: c,
    ...o,
    children: a.map((d, u) => l && u > 0 ? /* @__PURE__ */ h(Ft, {
      children: [/* @__PURE__ */ n(te, {}), /* @__PURE__ */ n(V, {
        component: s,
        className: Dt.item,
        children: d
      })]
    }, u) : /* @__PURE__ */ n(V, {
      component: s,
      className: Dt.item,
      children: d
    }, u))
  });
}
Kt.displayName = "Stack";
const $s = be(null), Hs = () => {
  const e = Ge($s);
  if (e == null)
    throw new Error("Dialog components must be wrapped in <Dialog />");
  return e;
}, Zs = "_backdrop_klb8u_5", Bs = "_dialog_klb8u_33", Vs = "_card_klb8u_43", js = "_sm_klb8u_73", Gs = "_md_klb8u_77", Ws = "_lg_klb8u_81", qs = "_header_klb8u_90", Us = "_footer_klb8u_103", Ks = "_menu_klb8u_107", Qs = "_close_klb8u_115", q = {
  backdrop: Zs,
  "not-open": "_not-open_klb8u_23",
  "will-close": "_will-close_klb8u_27",
  dialog: Bs,
  card: Vs,
  sm: js,
  md: Gs,
  lg: Ws,
  header: qs,
  footer: Us,
  menu: Ks,
  close: Qs,
  "with-subtitle": "_with-subtitle_klb8u_123"
};
b(({
  children: e,
  title: t,
  subtitle: i,
  closeLabel: l = "Close",
  primaryAction: r,
  secondaryAction: o,
  tertiaryAction: a,
  size: s = "sm",
  hideFooterDivider: c = !1,
  portalRoot: d,
  ...u
}, _) => {
  const {
    context: p,
    setOpen: m,
    ...f
  } = Hs(), {
    isMounted: y,
    status: w
  } = Bi(p, {
    duration: {
      open: 300,
      close: 200
    }
  }), C = Vi([f.refs.setFloating, _]), v = E(null), x = (P) => {
    P.key === "Escape" && (P.stopPropagation(), m(!1));
  }, D = (P) => {
    const R = P.target, Z = !(R != null && R.classList.contains(q.backdrop)), $ = (R == null ? void 0 : R.closest("[data-floating-ui-portal]")) && Z, Y = R == null ? void 0 : R.closest("[data-radix-select-viewport]"), J = R == null ? void 0 : R.closest("[data-combobox-portal]");
    $ || Y || J || (P.stopPropagation(), m(!1));
  };
  z(() => {
    var P;
    w === "open" && ((P = v.current) == null || P.focus());
  }, [w, v]);
  const L = g([q.backdrop, w !== "open" && q["not-open"], w === "close" && q["will-close"]]), T = {
    children: e,
    title: t,
    subtitle: i,
    closeLabel: l,
    primaryAction: r,
    secondaryAction: o,
    tertiaryAction: a,
    size: s,
    hideFooterDivider: c,
    floatingProps: f.getFloatingProps(u),
    dialogRef: C,
    headerRef: v,
    setOpen: m,
    status: w
  };
  return y ? /* @__PURE__ */ n(We, {
    root: d,
    children: /* @__PURE__ */ n(Un, {
      className: L,
      lockScroll: !0,
      onPointerDown: D,
      onKeyDown: x,
      children: /* @__PURE__ */ n(dt, {
        context: p,
        children: /* @__PURE__ */ n(Ys, {
          ...T
        })
      })
    })
  }) : null;
});
function Ys({
  children: e,
  title: t,
  subtitle: i,
  closeLabel: l = "Close",
  primaryAction: r,
  secondaryAction: o,
  tertiaryAction: a,
  size: s = "sm",
  hideFooterDivider: c,
  floatingProps: d,
  dialogRef: u,
  headerRef: _,
  setOpen: p,
  status: m
}) {
  return /* @__PURE__ */ n("div", {
    ref: u,
    className: q.dialog,
    "aria-modal": !0,
    "aria-label": t,
    ...d,
    children: /* @__PURE__ */ h("article", {
      className: g(q.card, q[s], m !== "open" && q["not-open"]),
      children: [/* @__PURE__ */ n("header", {
        className: q.header,
        children: /* @__PURE__ */ h(Kt, {
          space: "small",
          children: [/* @__PURE__ */ n(ze, {
            ref: _,
            as: "h3",
            size: "large",
            weight: "semi-bold",
            tabIndex: -1,
            children: t
          }), i ? /* @__PURE__ */ n(ze, {
            weight: "medium",
            tone: "secondary",
            children: i
          }) : null]
        })
      }), e, /* @__PURE__ */ h("footer", {
        className: q.footer,
        children: [c ? null : /* @__PURE__ */ n("div", {
          style: {
            paddingBlockStart: "16px"
          },
          children: /* @__PURE__ */ n(te, {})
        }), /* @__PURE__ */ h("menu", {
          className: q.menu,
          children: [a ? N(a, {
            variant: "transparent",
            tone: a.props.tone || "accent",
            size: "md"
          }) : null, o ? N(o, {
            variant: "transparent",
            tone: o.props.tone || "accent",
            size: "md"
          }) : null, N(r, {
            variant: "solid",
            tone: r.props.tone || "accent",
            size: "md"
          })]
        }), /* @__PURE__ */ n("div", {
          className: g(q.close, i && q["with-subtitle"]),
          children: /* @__PURE__ */ n(G, {
            icon: /* @__PURE__ */ n(ht, {}),
            label: l,
            size: "lg",
            onClick: () => p(!1)
          })
        })]
      })]
    })
  });
}
const Js = b(({
  children: e,
  icon: t,
  variant: i = "standard",
  size: l = "md",
  round: r,
  onClick: o,
  disabled: a,
  ...s
}, c) => /* @__PURE__ */ h(V, {
  component: pt,
  ...s,
  ref: c,
  className: g(fe.root, fe[l], fe[i], r && fe["is-round"]),
  onClick: a ? void 0 : o,
  "aria-disabled": a,
  children: [N(t, {
    size: ve[l]
  }), e]
})), Xs = b(({
  label: e,
  ...t
}, i) => /* @__PURE__ */ n(ye, {
  ref: i,
  size: "large",
  removeOffset: !0,
  label: e,
  children: /* @__PURE__ */ n(Js, {
    ...t
  })
}));
Xs.displayName = "IconButtonLink";
const ec = "_root_10ymk_1", tc = "_sm_10ymk_14", nc = "_label_10ymk_20", ic = "_md_10ymk_31", lc = "_lg_10ymk_50", rc = "_subtle_10ymk_67", oc = "_bold_10ymk_71", ac = "_neutral_10ymk_75", sc = "_info_10ymk_89", cc = "_positive_10ymk_103", dc = "_caution_10ymk_117", uc = "_critical_10ymk_131", Le = {
  root: ec,
  sm: tc,
  label: nc,
  md: ic,
  lg: lc,
  subtle: rc,
  bold: oc,
  neutral: ac,
  info: sc,
  positive: cc,
  caution: dc,
  critical: uc,
  "is-interactive": "_is-interactive_10ymk_145"
}, Qt = b(({
  children: e,
  size: t = "md",
  tone: i = "neutral",
  weight: l = "subtle",
  count: r,
  icon: o,
  ...a
}, s) => {
  const c = Boolean(a.onClick), d = t === "lg" ? "subtle" : l, u = t === "sm" ? void 0 : r, _ = t === "sm" ? void 0 : o;
  return /* @__PURE__ */ h(V, {
    component: c ? "button" : "div",
    ref: s,
    type: c ? "button" : void 0,
    className: g(Le.root, Le[t], Le[d], Le[i], c && Le["is-interactive"]),
    ...a,
    children: [_ ? N(_, {
      size: t === "md" ? "16" : "20"
    }) : null, /* @__PURE__ */ n("div", {
      className: Le.label,
      children: e
    }), u ? /* @__PURE__ */ n(ri, {
      count: Number(u),
      variant: d === "bold" ? "heavy" : "light"
    }) : null]
  });
}), hc = "_root_1va1j_1", _c = "_shine_1va1j_9", xn = {
  root: hc,
  shine: _c
};
function pc({
  width: e = 60
}) {
  return /* @__PURE__ */ n("div", {
    className: xn.root,
    style: {
      width: e,
      height: "8px"
    },
    children: /* @__PURE__ */ n("div", {
      className: xn.shine
    })
  });
}
De({
  strict: !1,
  name: "PanelContext"
});
const [A_, mc] = De({
  strict: !1,
  name: "RadioGroupContext"
}), [O_, fc] = De({
  strict: !1,
  name: "RadioItemContext"
}), gc = "_button_1pjx7_1", vc = "_control_1pjx7_11", bc = "_input_1pjx7_31", yc = "_mixed_1pjx7_94", wc = "_icon_1pjx7_118", xc = "_item_1pjx7_124", Cc = "_right_1pjx7_129", Nc = "_label_1pjx7_135", kc = "_text_1pjx7_139", zc = "_disabled_1pjx7_145", Dc = "_group_1pjx7_154", ge = {
  button: gc,
  control: vc,
  input: bc,
  mixed: yc,
  icon: wc,
  item: xc,
  right: Cc,
  label: Nc,
  text: kc,
  disabled: zc,
  group: Dc,
  "group-label": "_group-label_1pjx7_163",
  "group-label-text": "_group-label-text_1pjx7_168"
}, pi = b(({
  checked: e,
  onChange: t,
  ...i
}, l) => /* @__PURE__ */ h("div", {
  className: ge.button,
  children: [/* @__PURE__ */ n("input", {
    ...i,
    ref: l,
    className: ge.input,
    type: "radio",
    checked: e,
    "aria-checked": e,
    onChange: t
  }), /* @__PURE__ */ n("div", {
    className: ge.control
  }), /* @__PURE__ */ n("div", {
    className: ge.icon,
    children: /* @__PURE__ */ n("svg", {
      width: "18",
      height: "18",
      fill: "none",
      viewBox: "0 0 18 18",
      "aria-hidden": !0,
      children: e ? /* @__PURE__ */ h("g", {
        children: [/* @__PURE__ */ n("path", {
          fill: "#000",
          fillOpacity: ".08",
          d: "M13 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
        }), /* @__PURE__ */ n("path", {
          fill: "#fff",
          d: "M13 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
        })]
      }) : null
    })
  })]
}));
pi.displayName = "RadioButton";
const Rc = b(({
  value: e,
  label: t,
  ...i
}, l) => {
  const r = mc(), o = fc(), {
    id: a,
    value: s,
    name: c,
    onChange: d,
    disabled: u
  } = r, _ = `${a}_${o}`, p = s === e, m = u || i.disabled, f = p || o === 0 && !s;
  return /* @__PURE__ */ h("div", {
    className: ge.item,
    children: [/* @__PURE__ */ n(pi, {
      ref: l,
      id: _,
      name: c,
      value: e,
      checked: p,
      onChange: d,
      disabled: m,
      tabIndex: f ? 0 : -1
    }), /* @__PURE__ */ n("div", {
      className: ge.label,
      children: /* @__PURE__ */ n("label", {
        className: g(ge.text, m && ge.disabled),
        htmlFor: _,
        children: t
      })
    })]
  });
});
Rc.displayName = "RadioItem";
const Sc = "_button_ax0d4_1", Ic = "_shortcut_ax0d4_21", Ec = "_icon_ax0d4_33", Pc = "_text_ax0d4_45", Ye = {
  button: Sc,
  shortcut: Ic,
  icon: Ec,
  text: Pc
};
b(({
  children: e,
  ...t
}, i) => {
  const l = Zt(), r = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ? "\u2318" : "Ctrl";
  return /* @__PURE__ */ h("button", {
    type: "button",
    ...t,
    className: Ye.button,
    ref: i,
    "aria-labelledby": l,
    children: [/* @__PURE__ */ n("div", {
      className: Ye.icon,
      children: /* @__PURE__ */ n(gl, {
        size: "20"
      })
    }), /* @__PURE__ */ n("span", {
      className: Ye.text,
      id: l,
      children: "Search"
    }), /* @__PURE__ */ n("div", {
      className: Ye.shortcut,
      children: /* @__PURE__ */ h("kbd", {
        children: [/* @__PURE__ */ n("kbd", {
          children: r
        }), " + ", /* @__PURE__ */ n("kbd", {
          children: "K"
        })]
      })
    })]
  });
});
function Cn(e) {
  return typeof e == "string";
}
function mi(e) {
  return typeof e == "object" && "options" in e && e.options != null;
}
function Nn(e) {
  return {
    label: e,
    value: e
  };
}
function Mc(e) {
  if (Cn(e))
    return Nn(e);
  if (mi(e)) {
    const { title: t, options: i } = e;
    return {
      title: t,
      options: i.map(
        (l) => Cn(l) ? Nn(l) : l
      )
    };
  }
  return e;
}
const Lc = "_trigger_1v1b6_1", Tc = "_critical_1v1b6_30", Ac = "_full_1v1b6_40", Oc = "_icon_1v1b6_45", Fc = "_listbox_1v1b6_49", $c = "_divider_1v1b6_61", Hc = "_group_1v1b6_66", Zc = "_title_1v1b6_72", Bc = "_option_1v1b6_82", Vc = "_indicator_1v1b6_117", U = {
  trigger: Lc,
  critical: Tc,
  full: Ac,
  icon: Oc,
  listbox: Fc,
  divider: $c,
  group: Hc,
  title: Zc,
  option: Bc,
  indicator: Vc,
  "scroll-button": "_scroll-button_1v1b6_128"
}, jc = b(({
  options: e,
  id: t,
  placeholder: i = "Select...",
  fullWidth: l,
  error: r,
  ...o
}, a) => {
  const s = e.map(Mc), c = s.length < 1 || o.disabled;
  return /* @__PURE__ */ n(gt, {
    id: t,
    tone: r ? "critical" : "neutral",
    ...o,
    children: ({
      id: d,
      ...u
    }) => /* @__PURE__ */ h(B.Root, {
      ...u,
      disabled: c,
      children: [/* @__PURE__ */ h(B.Trigger, {
        ref: a,
        className: g(U.trigger, l && U.full, (r || o.tone === "critical") && U.critical),
        id: d,
        children: [/* @__PURE__ */ n(Bt, {
          lines: 1,
          children: /* @__PURE__ */ n(B.Value, {
            placeholder: i
          })
        }), /* @__PURE__ */ n(B.Icon, {
          className: U.icon,
          children: /* @__PURE__ */ n(ee, {
            size: "20",
            direction: "down"
          })
        })]
      }), /* @__PURE__ */ n(B.Portal, {
        children: /* @__PURE__ */ h(B.Content, {
          collisionPadding: 4,
          className: U.listbox,
          children: [/* @__PURE__ */ n(B.ScrollUpButton, {
            className: U["scroll-button"],
            children: /* @__PURE__ */ n(ee, {
              size: "20",
              direction: "up"
            })
          }), /* @__PURE__ */ n(B.Viewport, {
            className: U.viewport,
            children: s.map(Wc)
          }), /* @__PURE__ */ n(B.ScrollDownButton, {
            className: U["scroll-button"],
            children: /* @__PURE__ */ n(ee, {
              size: "20",
              direction: "down"
            })
          })]
        })
      })]
    })
  });
}), Gc = () => /* @__PURE__ */ n("div", {
  className: U.divider,
  children: /* @__PURE__ */ n(te, {})
}), fi = b((e, t) => /* @__PURE__ */ n(B.Group, {
  ...e,
  ref: t,
  className: U.group
})), gi = b((e, t) => /* @__PURE__ */ n(B.Label, {
  ...e,
  ref: t,
  className: U.title
})), vi = b(({
  children: e,
  ...t
}, i) => /* @__PURE__ */ h(B.Item, {
  ...t,
  ref: i,
  className: U.option,
  children: [/* @__PURE__ */ n(B.ItemIndicator, {
    className: U.indicator,
    children: /* @__PURE__ */ n(ei, {
      size: "20"
    })
  }), /* @__PURE__ */ n(B.ItemText, {
    children: e
  })]
}));
jc.displayName = "Select";
fi.displayName = "SelectGroup";
gi.displayName = "SelectTitle";
vi.displayName = "SelectOption";
function kn({
  label: e,
  ...t
}) {
  return /* @__PURE__ */ n(vi, {
    ...t,
    children: e
  }, t.value);
}
function Wc(e, t) {
  if (mi(e)) {
    const {
      title: i,
      options: l
    } = e;
    return /* @__PURE__ */ h(Ft, {
      children: [t === 0 ? null : /* @__PURE__ */ n(Gc, {}), /* @__PURE__ */ h(fi, {
        children: [/* @__PURE__ */ n(gi, {
          children: i
        }), l.map(kn)]
      })]
    }, i);
  }
  return kn(e);
}
const qc = "_container_m1bz0_1", Uc = "_label_m1bz0_7", Kc = "_positive_m1bz0_14", Qc = "_warning_m1bz0_18", Yc = "_negative_m1bz0_22", Jc = "_info_m1bz0_26", Xc = "_filled_m1bz0_30", ed = "_outlined_m1bz0_34", je = {
  container: qc,
  label: Uc,
  positive: Kc,
  warning: Qc,
  negative: Yc,
  info: Jc,
  filled: Xc,
  outlined: ed
};
function td(e, t, i) {
  const l = /* @__PURE__ */ n("p", {
    className: je.label,
    children: t
  });
  return /* @__PURE__ */ h(j, {
    children: [i === "left" ? l : null, e, i === "right" ? l : null]
  });
}
const nd = b(({
  label: e,
  labelId: t,
  tone: i = "positive",
  outlined: l = !1,
  align: r = "left"
}, o) => {
  const a = l ? {
    x: "1",
    y: "1",
    width: "8",
    height: "8",
    strokeWidth: "2"
  } : null, s = /* @__PURE__ */ h("svg", {
    ref: o,
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    ...e ? {
      role: "img",
      "aria-labelledby": t
    } : {
      "aria-hidden": !0
    },
    children: [e ? /* @__PURE__ */ n("title", {
      id: t,
      children: e
    }) : null, /* @__PURE__ */ n("rect", {
      width: "10",
      height: "10",
      rx: "5",
      className: g(je[i], l ? je.outlined : je.filled),
      ...a
    })]
  });
  return /* @__PURE__ */ n("div", {
    className: g(je.container),
    children: e ? td(s, e, r) : s
  });
});
nd.displayName = "StatusLight";
const id = "_root_fr0nt_1", ld = "_xs_fr0nt_5", rd = "_sm_fr0nt_10", od = "_md_fr0nt_15", ad = "_lg_fr0nt_20", sd = "_input_fr0nt_26", cd = "_track_fr0nt_39", dd = "_handle_fr0nt_49", ke = {
  root: id,
  xs: ld,
  sm: rd,
  md: od,
  lg: ad,
  input: sd,
  track: cd,
  handle: dd,
  "icon-on": "_icon-on_fr0nt_85",
  "icon-off": "_icon-off_fr0nt_100"
}, zn = {
  xs: "12",
  sm: "16",
  md: "20",
  lg: "24"
}, bi = b(({
  id: e,
  checked: t,
  onChange: i,
  disabled: l,
  size: r = "md",
  showIcons: o,
  ...a
}, s) => /* @__PURE__ */ h("div", {
  className: g(ke.root, ke[r]),
  children: [/* @__PURE__ */ n("input", {
    ...a,
    ref: s,
    className: ke.input,
    id: e,
    type: "checkbox",
    checked: t,
    onChange: l ? () => {
    } : i,
    "aria-disabled": l
  }), /* @__PURE__ */ n("div", {
    className: ke.track,
    children: o ? /* @__PURE__ */ h(j, {
      children: [/* @__PURE__ */ n("div", {
        className: ke["icon-on"],
        children: /* @__PURE__ */ n(ti, {
          size: zn[r]
        })
      }), /* @__PURE__ */ n("div", {
        className: ke["icon-off"],
        children: /* @__PURE__ */ n(Cl, {
          size: zn[r]
        })
      })]
    }) : null
  }), /* @__PURE__ */ n("div", {
    className: ke.handle
  })]
}));
bi.displayName = "Switch";
be(null);
be(null);
be(null);
const ud = {
  text: "text",
  password: "text",
  email: "email",
  search: "search",
  number: "numeric",
  tel: "tel",
  url: "url"
}, hd = b(({
  value: e,
  type: t = "text",
  inputMode: i,
  step: l,
  onChange: r,
  onFocus: o,
  onBlur: a,
  id: s,
  placeholder: c,
  ...d
}, u) => /* @__PURE__ */ n(gt, {
  ...d,
  id: s,
  value: e,
  children: (_, p) => /* @__PURE__ */ h(j, {
    children: [p, /* @__PURE__ */ n("input", {
      ref: u,
      type: t,
      value: e,
      inputMode: i || ud[t],
      step: l,
      onChange: r,
      onFocus: o,
      onBlur: a,
      placeholder: d.disabled ? void 0 : c,
      ..._
    })]
  })
}));
hd.displayName = "TextField";
const _d = "_textarea_vw3z0_1", pd = {
  textarea: _d
}, Rt = (e) => typeof e == "string" ? parseInt(e.replace("px", ""), 10) : 0, md = (e, t, i) => {
  const {
    paddingBottom: l,
    paddingTop: r,
    lineHeight: o
  } = window.getComputedStyle(e);
  if (!o.endsWith("px"))
    return t;
  const a = Rt(r) + Rt(l), s = Math.floor((e.scrollHeight - a) / Rt(o));
  return e && e.value === "" ? t : typeof i == "number" && s > i ? i : s;
}, fd = b(({
  onChange: e,
  onFocus: t,
  onBlur: i,
  onPaste: l,
  placeholder: r,
  spellCheck: o,
  lines: a = 3,
  grow: s = !0,
  maxLines: c,
  ...d
}, u) => {
  const [_, p] = k(a), m = (f) => {
    s && p(md(f.currentTarget, a, c)), typeof e == "function" && e(f);
  };
  return /* @__PURE__ */ n(gt, {
    ...d,
    children: ({
      className: f,
      ...y
    }) => /* @__PURE__ */ n("textarea", {
      ref: u,
      className: g(f, pd.textarea),
      rows: _,
      spellCheck: o,
      onChange: m,
      onFocus: t,
      onBlur: i,
      onPaste: l,
      placeholder: d.disabled ? void 0 : r,
      ...y
    })
  });
});
function gd({ onTimeout: e, duration: t }) {
  const [i, l] = k(!0), r = E(), o = H(() => {
    window.clearTimeout(r.current), l(!1);
  }, []);
  z(() => {
    if (i)
      return r.current = window.setTimeout(() => {
        e == null || e();
      }, t), () => {
        o();
      };
  }, [e, i, t, o]);
  const a = H(() => {
    l(!0);
  }, []);
  return {
    stopTimeout: o,
    startTimeout: a
  };
}
const vd = "_toast_1it71_1", bd = "_info_1it71_19", yd = "_positive_1it71_25", wd = "_caution_1it71_31", xd = "_critical_1it71_37", Cd = "_contents_1it71_44", Nd = "_icon_1it71_52", kd = "_text_1it71_57", zd = "_actions_1it71_63", Dd = "_action_1it71_63", Rd = "_toaster_1it71_88", re = {
  "toast-container": "_toast-container_1it71_1",
  "toast-shadow": "_toast-shadow_1it71_5",
  toast: vd,
  info: bd,
  positive: yd,
  caution: wd,
  critical: xd,
  contents: Cd,
  icon: Nd,
  text: kd,
  actions: zd,
  action: Dd,
  toaster: Rd
}, Sd = 6e3, Id = {
  info: ml,
  positive: ti,
  caution: _l,
  critical: ul
}, Dn = ({
  label: e,
  onClick: t,
  removeToast: i
}) => {
  const l = H((r) => {
    i == null || i(), t(r);
  }, [i, t]);
  return /* @__PURE__ */ n("button", {
    className: re.action,
    type: "button",
    onClick: l,
    children: e
  });
};
b(({
  id: e,
  tone: t = "info",
  message: i,
  onClose: l,
  closeLabel: r = "Dismiss",
  action: o,
  disableAutoDismiss: a
}, s) => {
  const c = H(() => l(e), [l, e]), {
    stopTimeout: d,
    startTimeout: u
  } = gd({
    duration: Sd,
    onTimeout: c
  });
  z(() => {
    a && d();
  }, [a, d]);
  const _ = Id[t];
  return /* @__PURE__ */ n("div", {
    className: re["toast-container"],
    ref: s,
    role: "alert",
    onMouseEnter: d,
    onMouseLeave: u,
    children: /* @__PURE__ */ n("div", {
      className: re["toast-shadow"],
      children: /* @__PURE__ */ h("div", {
        className: g(re.toast, re[t]),
        children: [/* @__PURE__ */ h("div", {
          className: re.contents,
          children: [/* @__PURE__ */ n("div", {
            className: re.icon,
            children: /* @__PURE__ */ n(_, {
              size: "24"
            })
          }), /* @__PURE__ */ n("div", {
            className: re.message,
            children: /* @__PURE__ */ n("span", {
              className: re.text,
              children: i
            })
          })]
        }), /* @__PURE__ */ n(te, {
          vertical: !0,
          inverted: !0
        }), /* @__PURE__ */ h("div", {
          className: re.actions,
          children: [o ? /* @__PURE__ */ h(j, {
            children: [/* @__PURE__ */ n(Dn, {
              removeToast: c,
              ...o
            }), /* @__PURE__ */ n(te, {
              inverted: !0
            })]
          }) : null, /* @__PURE__ */ n(Dn, {
            label: r,
            onClick: c
          })]
        })]
      })
    })
  });
});
be(null);
const Ed = "_disabled_dfy2c_6", Pd = {
  disabled: Ed
};
function Md(e, t) {
  const {
    defaultPressed: i,
    pressed: l,
    onPressedChange: r,
    ...o
  } = e, [a, s] = _t({
    defaultProp: i != null ? i : !1,
    prop: l,
    onChange: r
  });
  return /* @__PURE__ */ n(he, {
    ref: t,
    className: o.disabled ? Pd.disabled : void 0,
    ...o,
    "aria-pressed": a,
    onClick: mt(o.onClick, () => {
      o.disabled || s(!a);
    })
  });
}
b(Md);
const [F_, Ld] = De({
  strict: !1,
  name: "ToggleGroupContext"
}), Td = b(({
  label: e,
  onClick: t,
  ...i
}, l) => {
  const r = Ld(), o = r.value.includes(i.value), a = (c) => {
    c ? r.onItemActivate(i.value) : r.onItemDeactivate(i.value);
  }, s = {
    ref: e ? void 0 : l,
    tone: "neutral",
    variant: "muted",
    "aria-pressed": o,
    disabled: o,
    onClick: mt(t, () => a(!o))
  };
  return e ? /* @__PURE__ */ n(ye, {
    label: e,
    size: "large",
    ref: l,
    children: /* @__PURE__ */ n(he, {
      ...i,
      ...s,
      "aria-label": e
    })
  }) : /* @__PURE__ */ n(he, {
    ...i,
    ...s,
    children: i.children
  });
});
Td.displayName = "ToggleGroupItem";
const Ad = "_wrapper_1t8hb_1", Od = "_cell_1t8hb_11", Rn = {
  wrapper: Ad,
  cell: Od
};
function Yt(e) {
  return function(i) {
    return /* @__PURE__ */ n("div", {
      className: Rn.wrapper,
      children: /* @__PURE__ */ n("div", {
        className: Rn.cell,
        children: e(i)
      })
    });
  };
}
const Fd = (e, t) => {
  switch (t.type) {
    case "TABLE/SET_IS_RESIZING":
      return {
        ...e,
        isLocked: t.payload.isResizing,
        isResizing: t.payload.isResizing
      };
    case "TABLE/SET_IS_DRAGGING_COLUMN":
      return {
        ...e,
        isLocked: t.payload.isDraggingColumn,
        isDraggingColumn: t.payload.isDraggingColumn
      };
    default:
      return e;
  }
}, yi = {
  isLocked: !1,
  isDraggingColumn: !1,
  isResizing: !1
}, $d = () => {
}, Jt = be({
  state: yi,
  dispatch: $d
});
Jt.displayName = "TableStore";
const Hd = ({
  children: e
}) => {
  const [t, i] = Pi(Fd, yi), l = Fe(() => ({
    state: t,
    dispatch: i
  }), [t]);
  return /* @__PURE__ */ n(Jt.Provider, {
    value: l,
    children: e
  });
}, vt = () => Ge(Jt), Lt = (e) => e == null ? "" : typeof e == "string" ? e : $t(e) ? Lt(e.props.children) : Array.isArray(e) ? e.map(Lt).join("") : String(e), Zd = (e, t) => {
  const [i, l] = k(!1);
  return Hn(() => {
    const {
      current: r
    } = e, o = "ResizeObserver" in window, a = () => {
      if (r) {
        const c = r.scrollWidth > r.clientWidth || r.scrollHeight > r.clientHeight;
        l(c), t == null || t(c);
      }
    }, s = o ? new ResizeObserver(a) : null;
    return r && (a(), o && (s == null || s.observe(r))), () => {
      r && (s == null || s.unobserve(r));
    };
  }, [e, t]), i;
}, Bd = ({
  children: e,
  label: t
}) => () => {
  const i = E(null), [l, r] = k(!1);
  return Zd(i, (o) => {
    r(o);
  }), l ? /* @__PURE__ */ n(ye, {
    ref: i,
    label: t,
    children: e
  }) : N(e, {
    ref: i
  });
}, Vd = "_text_17rvh_1", jd = "_small_17rvh_13", Gd = "_medium_17rvh_17", Wd = "_large_17rvh_21", qd = "_uppercase_17rvh_29", Ud = "_left_17rvh_33", Kd = "_center_17rvh_37", Qd = "_right_17rvh_41", Yd = "_normal_17rvh_45", Jd = "_primary_17rvh_53", Xd = "_secondary_17rvh_57", eu = "_white_17rvh_61", tu = "_info_17rvh_65", nu = "_positive_17rvh_69", iu = "_caution_17rvh_73", lu = "_critical_17rvh_77", ru = "_truncate_17rvh_81", ou = "_multiline_17rvh_89", me = {
  text: Vd,
  small: jd,
  medium: Gd,
  large: Wd,
  "extra-large": "_extra-large_17rvh_25",
  uppercase: qd,
  left: Ud,
  center: Kd,
  right: Qd,
  normal: Yd,
  "semi-bold": "_semi-bold_17rvh_49",
  primary: Jd,
  secondary: Xd,
  white: eu,
  info: tu,
  positive: nu,
  caution: iu,
  critical: lu,
  truncate: ru,
  multiline: ou
}, ue = b(({
  children: e,
  align: t,
  as: i = "span",
  lines: l = 1,
  numeric: r = "tabular-nums",
  showTooltip: o = !1,
  size: a = "medium",
  tone: s = "primary",
  transform: c = "none",
  weight: d = "normal"
}, u) => {
  const _ = l ? /* @__PURE__ */ n("div", {
    className: g(me.truncate, l > 1 && me.multiline),
    children: e
  }) : /* @__PURE__ */ n(j, {
    children: e
  });
  let p;
  if (o) {
    const m = Bd({
      children: _,
      label: Lt(e)
    });
    p = /* @__PURE__ */ n(m, {});
  }
  return /* @__PURE__ */ n(V, {
    ref: u,
    component: i,
    className: g(me.text, t && me[t], me[a], me[s], me[c], me[d]),
    style: {
      "--ic-tabletext-numeric": i === "time" ? "lining-nums" : r,
      "--ic-tabletext-lines": l
    },
    children: o ? p : _
  });
}), Sn = {
  "header-group": "_header-group_1hln5_1",
  "is-dragging": "_is-dragging_1hln5_11"
}, au = ({
  columnGroup: e,
  displayName: t,
  setExpanded: i
}) => {
  const {
    state: {
      isDraggingColumn: l
    }
  } = vt(), r = e.getProvidedColumnGroup().isExpanded(), o = () => {
    i(!r);
  };
  return /* @__PURE__ */ h(V, {
    className: g(Sn["header-group"], l && Sn["is-dragging"]),
    onClick: () => o(),
    children: [/* @__PURE__ */ n(ue, {
      size: "small",
      tone: "secondary",
      showTooltip: !0,
      transform: "uppercase",
      weight: "semi-bold",
      children: t
    }), e.isExpandable() && /* @__PURE__ */ n("svg", {
      style: {
        minWidth: 20,
        transform: r ? "rotate(0deg)" : "rotate(180deg)"
      },
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ n("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.192 6.69199L10.884 10L14.192 13.3081L13.3081 14.192L9.55813 10.442L9.11619 10L9.55813 9.55811L13.3081 5.80811L14.192 6.69199ZM10.442 6.692L7.13393 10.0001L10.442 13.3081L9.5581 14.192L5.8081 10.442L5.36616 10.0001L5.8081 9.55812L9.5581 5.80812L10.442 6.692Z",
        fill: "#6E6E6E"
      })
    })]
  });
}, $_ = Yt(au);
function su() {
  const e = `${30 + Math.random() * 20}%`;
  return /* @__PURE__ */ n("div", {
    style: {
      padding: "4px 16px",
      width: "100%"
    },
    children: /* @__PURE__ */ n(pc, {
      width: e
    })
  });
}
const wi = "TABLE/SET_IS_RESIZING", xi = "TABLE/SET_IS_DRAGGING_COLUMN", cu = "_overlay_3208n_1", du = "_interactive_3208n_17", In = {
  overlay: cu,
  interactive: du
};
function uu({
  id: e
}) {
  const {
    state: {
      isLocked: t
    },
    dispatch: i
  } = vt(), [l, r] = k(80);
  return z(() => {
    const o = document.querySelector(`#${e} .ag-header-container`);
    !o || r(o.clientHeight);
  }, [t, e]), t ? /* @__PURE__ */ n("div", {
    className: g(In.overlay),
    style: {
      height: `calc(100% - ${l}px)`,
      top: l
    },
    children: /* @__PURE__ */ n("div", {
      className: In.interactive,
      children: /* @__PURE__ */ n(he, {
        tone: "accent",
        variant: "solid",
        size: "lg",
        onClick: () => {
          i({
            type: wi,
            payload: {
              isResizing: !1
            }
          }), i({
            type: xi,
            payload: {
              isDraggingColumn: !1
            }
          });
        },
        children: "Done"
      })
    })
  }) : null;
}
const Xt = be({
  tables: {},
  setTables: () => {
  }
}), H_ = ({
  children: e
}) => {
  const [t, i] = k({}), l = Fe(() => ({
    tables: t,
    setTables: i
  }), [t]);
  return /* @__PURE__ */ n(Xt.Provider, {
    value: l,
    children: e
  });
}, Z_ = (e) => {
  const [t, i] = k(!0), r = Ge(Xt).tables[e], o = r == null || r.api == null || r.columnApi == null;
  return z(() => {
    o || i(!1);
  }, [o]), t || r === null ? {
    loading: t,
    table: null
  } : {
    loading: t,
    table: r
  };
};
function W({
  size: e = "32",
  title: t,
  titleId: i,
  ...l
}) {
  return {
    width: e,
    height: e,
    ...t ? { title: t, titleId: i, role: "img" } : { "aria-hidden": !0 },
    ...l
  };
}
function hu(e, t, i) {
  return {
    style: {
      ...i,
      rotate: t[e]
    }
  };
}
const _u = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    d: "m8.414 15 3.293-3.293-1.414-1.414L4.586 16l5.707 5.707 1.414-1.414L8.414 17H15v-2H8.414Zm15.172 0H17v2h6.586l-3.293 3.293 1.414 1.414L27.414 16l-5.707-5.707-1.414 1.414L23.586 15Z"
  })]
});
function pu(e) {
  const t = W(e);
  return /* @__PURE__ */ n(_u, {
    ...t
  });
}
const mu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    d: "M6 10a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1-7a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H7Z"
  })]
});
function fu(e) {
  const t = W(e);
  return /* @__PURE__ */ n(mu, {
    ...t
  });
}
const gu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "m16 17.586 5.293-5.293 1.414 1.414-6 6-.707.707-.707-.707-6-6 1.414-1.414L16 17.586Z",
    clipRule: "evenodd"
  })]
});
function en({
  direction: e = "down",
  ...t
}) {
  const i = W(t), l = hu(e, {
    up: "180deg",
    right: "270deg",
    down: "0deg",
    left: "90deg"
  });
  return /* @__PURE__ */ n(gu, {
    ...i,
    ...l
  });
}
const vu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M7 14h4v4H7v-4Zm7 0h4v4h-4v-4Zm11 0h-4v4h4v-4Z",
    clipRule: "evenodd"
  })]
});
function bu(e) {
  const t = W(e);
  return /* @__PURE__ */ n(vu, {
    ...t
  });
}
const yu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm1.156 13.611h-2.312v-7.36h2.312v7.36Zm.094 3.89h-2.5v-2.492h2.5V21.5Z",
    clipRule: "evenodd"
  })]
});
function wu(e) {
  const t = W(e);
  return /* @__PURE__ */ n(yu, {
    ...t
  });
}
const xu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "m23.771 11.143 1.936-1.936-1.414-1.414-16.5 16.5 1.414 1.414 2.794-2.794a13.34 13.34 0 0 0 4 .587c6.168 0 9.619-3.754 11.378-6.47a1.824 1.824 0 0 0-.045-2.032c-.808-1.164-1.964-2.618-3.563-3.855Zm-1.427 1.428-2.462 2.461A4.005 4.005 0 0 1 16 20a3.96 3.96 0 0 1-.968-.118l-1.388 1.388c.728.148 1.512.23 2.356.23 5.126 0 8.033-3.025 9.63-5.45-.787-1.12-1.851-2.42-3.286-3.48Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ n("path", {
    d: "M4.622 17.03c.846 1.307 2.083 2.854 3.827 4.107L9.886 19.7c-1.58-1.061-2.713-2.431-3.515-3.65 1.666-2.375 4.58-5.55 9.63-5.55.995 0 1.908.124 2.745.34l1.599-1.599A12.651 12.651 0 0 0 16 8.501c-6.117 0-9.561 3.944-11.334 6.497a1.824 1.824 0 0 0-.044 2.032Z"
  }), /* @__PURE__ */ n("path", {
    d: "m12.234 17.352 5.118-5.118a4 4 0 0 0-5.118 5.117Z"
  })]
});
function Cu(e) {
  const t = W(e);
  return /* @__PURE__ */ n(xu, {
    ...t
  });
}
const Nu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M16 26c-5.523 0-10-4.477-10-10S10.477 6 16 6s10 4.477 10 10-4.477 10-10 10ZM4 16C4 9.373 9.373 4 16 4s12 5.373 12 12-5.373 12-12 12S4 22.627 4 16Zm13.15-3.76h-2.32V10h2.32v2.24Zm0 9.872h-2.287v-8.48h2.288v8.48Z",
    clipRule: "evenodd"
  })]
});
function ku(e) {
  const t = W(e);
  return /* @__PURE__ */ n(Nu, {
    ...t
  });
}
const zu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M24.485 7.515a2 2 0 0 0-2.828 0l-1.414 1.414 2.828 2.828 1.414-1.414a2 2 0 0 0 0-2.828Zm-13.31 16.138 10.482-10.481-2.828-2.829L8.347 20.825l-.832 3.66 3.66-.832Z",
    clipRule: "evenodd"
  })]
});
function Du(e) {
  const t = W(e);
  return /* @__PURE__ */ n(zu, {
    ...t
  });
}
const Ru = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M8 4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h8V4H8ZM6 24V10h8v16H8a2 2 0 0 1-2-2Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ n("path", {
    d: "M24 26a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4h-5v2h5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-5v2h5Z"
  })]
});
function Su(e) {
  const t = W(e);
  return /* @__PURE__ */ n(Ru, {
    ...t
  });
}
const Iu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "M16 4v24h8a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4h-8Zm2 6v16h6a2 2 0 0 0 2-2V10h-8Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ n("path", {
    d: "M8 6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h5v-2H8a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h5V6H8Z"
  })]
});
function Eu(e) {
  const t = W(e);
  return /* @__PURE__ */ n(Iu, {
    ...t
  });
}
const Pu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    d: "M8 6v3h16V6h2v8h-2v-3H8v3H6V6h2Zm14 10a4 4 0 0 1 4 4v6h-2v-4H8v4H6v-6a4 4 0 0 1 4-4h12Z"
  })]
});
function Mu(e) {
  const t = W(e);
  return /* @__PURE__ */ n(Pu, {
    ...t
  });
}
const Lu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    d: "m10.879 20.256-1.686 1.685V6.025h-2v15.917l-1.686-1.686-1.414 1.415 4.1 4.1 4.1-4.1-1.414-1.415ZM19 11h-5V9h5v2Zm5 6v-2H14v2h10Zm-10 6h14v-2H14v2Z"
  })]
});
function Ci(e) {
  const t = W(e);
  return /* @__PURE__ */ n(Lu, {
    ...t
  });
}
const Tu = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "m5.507 11.54 1.686-1.686V25.77h2V9.853l1.686 1.686 1.414-1.414L8.9 6.732l-.707-.707-.707.707-3.393 3.393 1.414 1.414ZM14 11h14V9H14v2Zm0 6h10v-2H14v2Zm5 6h-5v-2h5v2Z",
    clipRule: "evenodd"
  })]
});
function Ni(e) {
  const t = W(e);
  return /* @__PURE__ */ n(Tu, {
    ...t
  });
}
const Au = ({
  title: e,
  titleId: t,
  ...i
}) => /* @__PURE__ */ h("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  focusable: "false",
  fill: "currentColor",
  "aria-labelledby": t,
  ...i,
  children: [e ? /* @__PURE__ */ n("title", {
    id: t,
    children: e
  }) : null, /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    d: "m16 17.414 4.95 4.95 1.414-1.414-4.95-4.95 4.95-4.95-1.414-1.414-4.95 4.95-4.95-4.95-1.414 1.414 4.95 4.95-4.95 4.95 1.414 1.414 4.95-4.95Z",
    clipRule: "evenodd"
  })]
});
function ki(e) {
  const t = W(e);
  return /* @__PURE__ */ n(Au, {
    ...t
  });
}
const Ou = "_actions_m3une_1", Fu = {
  actions: Ou
};
function $u(e) {
  return function(i) {
    const {
      colDef: l,
      menu: r
    } = i, o = typeof (l == null ? void 0 : l.editable) == "function" ? l.editable(i) : !!(l != null && l.editable);
    let a = null;
    if (o) {
      const {
        api: c,
        column: d,
        node: u
      } = i, _ = d == null ? void 0 : d.getColId(), p = u == null ? void 0 : u.rowIndex;
      a = /* @__PURE__ */ n("div", {
        style: {
          backgroundColor: "white",
          borderRadius: "var(--i-radius-small)"
        },
        children: /* @__PURE__ */ n(G, {
          onClick: () => {
            _ == null || p == null || c.startEditingCell({
              colKey: _,
              rowIndex: p
            });
          },
          variant: "subtle",
          size: "lg",
          label: "Edit",
          icon: /* @__PURE__ */ n(Du, {})
        })
      });
    }
    let s = null;
    if (r != null) {
      const c = r(i), {
        contents: d,
        icon: u
      } = c;
      s = /* @__PURE__ */ h(Gt, {
        placement: "bottom-end",
        children: [/* @__PURE__ */ n(ft, {
          children: (_) => /* @__PURE__ */ n("div", {
            style: {
              backgroundColor: "white",
              borderRadius: "var(--i-radius-small)"
            },
            children: /* @__PURE__ */ n(G, {
              variant: "subtle",
              size: "lg",
              label: "Menu",
              icon: u != null ? u : /* @__PURE__ */ n(bu, {}),
              ..._
            })
          })
        }), /* @__PURE__ */ n(qt, {
          children: d
        })]
      });
    }
    return a || s ? /* @__PURE__ */ h(j, {
      children: [e(i), /* @__PURE__ */ h("div", {
        className: Fu.actions,
        children: [a, s]
      })]
    }) : e(i);
  };
}
function Hu(e) {
  return function(i) {
    const {
      cellHighlighting: l
    } = i, r = l == null ? void 0 : l(i);
    if (!r)
      return e(i);
    const o = e(i);
    if (!o)
      return null;
    const {
      backgroundColor: a,
      iconColor: s
    } = r, c = {
      "--ic-table-cell-background-color": a != null ? a : "var(--i-neutral-100)",
      "--ic-table-cell-icon-color": s != null ? s : "var(--i-text-primary)"
    };
    return N(o, {
      ...o.props,
      style: {
        ...c,
        ...o.props.style
      }
    });
  };
}
const Zu = "_icon_h5pwf_8", En = {
  "cell-highlighting-wrapper": "_cell-highlighting-wrapper_h5pwf_1",
  icon: Zu
};
function Bu(e) {
  return function(i) {
    const {
      cellHighlighting: l
    } = i;
    return l != null ? /* @__PURE__ */ h("div", {
      className: En["cell-highlighting-wrapper"],
      children: [e(i), /* @__PURE__ */ n("div", {
        "aria-label": "Cell Highlighting Symbol",
        className: En.icon,
        children: /* @__PURE__ */ n("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "currentColor",
          children: /* @__PURE__ */ n("rect", {
            x: "3",
            y: "8",
            width: "7",
            height: "7",
            rx: "0.942809",
            transform: "rotate(-45 3 8)",
            fill: "currentColor"
          })
        })
      })]
    }) : e(i);
  };
}
const Vu = "_wrapper_1r4lm_15", Pn = {
  wrapper: Vu,
  "edit-failed-icon": "_edit-failed-icon_1r4lm_20",
  "fade-in-edit-failed": "_fade-in-edit-failed_1r4lm_1"
}, ju = () => /* @__PURE__ */ n("div", {
  className: Pn.wrapper,
  children: /* @__PURE__ */ n(wu, {
    className: Pn["edit-failed-icon"],
    color: "red",
    size: "20"
  })
});
function Gu(e) {
  return function(i) {
    var o, a;
    const {
      colDef: l,
      node: r
    } = i;
    return ((o = l == null ? void 0 : l.cellRendererParams) == null ? void 0 : o.error) === !0 && r.id === ((a = l == null ? void 0 : l.cellRendererParams) == null ? void 0 : a.nodeId) ? /* @__PURE__ */ n(ju, {}) : e(i);
  };
}
function Wu(e) {
  const {
    node: t
  } = e, [i, l] = k(t.expanded);
  z(() => {
    const o = (a) => l(a.node.expanded);
    return t.addEventListener(cn.EVENT_EXPANDED_CHANGED, o), () => {
      t.removeEventListener(cn.EVENT_EXPANDED_CHANGED, o);
    };
  }, [t]);
  const r = H(() => t.setExpanded(!t.expanded), [t]);
  return {
    expanded: i,
    toggleExpandRow: r
  };
}
const qu = "_group_l3vs3_1", Uu = "_button_l3vs3_8", Mn = {
  group: qu,
  button: Uu
}, Ku = ({
  params: e,
  children: t
}) => {
  const {
    expanded: i,
    toggleExpandRow: l
  } = Wu(e), {
    node: r
  } = e;
  return /* @__PURE__ */ h("div", {
    className: Mn.group,
    children: [/* @__PURE__ */ n("div", {
      className: Mn.button,
      style: {
        padding: `0 0 0 ${r.level * 8}px`
      },
      children: /* @__PURE__ */ n(
        G,
        {
          onClickCapture: (o) => {
            o.nativeEvent.stopPropagation(), l();
          },
          "aria-expanded": i,
          label: i ? "Collapse" : "Expand",
          size: "md",
          icon: /* @__PURE__ */ n(en, {
            direction: i ? "down" : "right"
          })
        }
      )
    }), t]
  });
};
function Qu(e) {
  return function(i) {
    const {
      node: l,
      colDef: r
    } = i;
    return (r == null ? void 0 : r.showRowGroup) ? l.group ? /* @__PURE__ */ n(Ku, {
      params: i,
      children: e(i)
    }) : null : e(i);
  };
}
const Yu = "_trigger_o0m3q_1", Ju = "_content_o0m3q_7", Ln = {
  trigger: Yu,
  content: Ju
};
function Xu({
  title: e,
  text: t,
  content: i,
  children: l,
  maxWidth: r = 160,
  onClose: o
}) {
  const a = e != null;
  return /* @__PURE__ */ h($l, {
    onOpenChange: (s) => {
      s || o == null || o();
    },
    placement: "right",
    children: [/* @__PURE__ */ n(Vl, {
      children: /* @__PURE__ */ n("div", {
        className: Ln.trigger,
        children: l
      })
    }), /* @__PURE__ */ n(Bl, {
      children: /* @__PURE__ */ h("div", {
        style: {
          maxWidth: r
        },
        className: Ln.content,
        children: [e ? /* @__PURE__ */ n(ze, {
          variant: "title",
          size: "small",
          tone: "white",
          children: e
        }) : null, t ? /* @__PURE__ */ n(ze, {
          variant: "body",
          size: a ? "small" : "medium",
          weight: a ? "normal" : "semi-bold",
          tone: "white",
          children: t
        }) : null, i]
      })
    })]
  });
}
function eh(e) {
  return function(i) {
    const {
      hoverCard: l
    } = i;
    if (!l)
      return e(i);
    const r = l(i);
    if (r) {
      const {
        title: o,
        text: a,
        content: s,
        maxWidth: c
      } = r;
      return /* @__PURE__ */ n(Xu, {
        title: o,
        text: a,
        content: s,
        maxWidth: c,
        children: e(i)
      });
    }
    return e(i);
  };
}
const th = () => /* @__PURE__ */ n("div", {
  style: {
    display: "grid",
    placeItems: "center"
  },
  children: /* @__PURE__ */ n(Mt, {})
});
function nh(e) {
  return function(i) {
    var o, a;
    const {
      colDef: l,
      node: r
    } = i;
    return (a = (o = l == null ? void 0 : l.cellRendererParams) == null ? void 0 : o.loading) != null && a.includes(r.id) ? /* @__PURE__ */ n(th, {}) : e(i);
  };
}
const ih = "_cell_jzu10_30", St = {
  "menu-container": "_menu-container_jzu10_1",
  "menu-icon": "_menu-icon_jzu10_16",
  cell: ih
}, zi = ({
  title: e,
  value: t,
  align: i,
  menuContents: l
}) => {
  const r = /* @__PURE__ */ h("div", {
    className: St.cell,
    children: [/* @__PURE__ */ n(ue, {
      size: "small",
      tone: l ? "info" : "secondary",
      align: i,
      children: e
    }), /* @__PURE__ */ n(ue, {
      size: "large",
      align: i,
      weight: "semi-bold",
      children: t
    })]
  });
  return l == null ? r : /* @__PURE__ */ h("div", {
    className: g(St["menu-container"]),
    children: [r, /* @__PURE__ */ n("div", {
      className: St["menu-icon"],
      children: /* @__PURE__ */ h(Gt, {
        placement: "bottom-end",
        children: [/* @__PURE__ */ n(ft, {
          children: (o) => /* @__PURE__ */ n(G, {
            ...o,
            variant: "subtle",
            size: "md",
            label: "Menu",
            icon: /* @__PURE__ */ n(en, {
              direction: "down"
            })
          })
        }), /* @__PURE__ */ n(qt, {
          children: l
        })]
      })
    })]
  });
}, Tn = (e) => zi(e), An = ({
  items: e
}) => {
  const [t, i] = k(0), {
    title: l,
    align: r,
    value: o
  } = e[t];
  return zi({
    title: l,
    align: r,
    value: o,
    menuContents: e.map((a, s) => {
      var c, d;
      return /* @__PURE__ */ n(ae, {
        onClick: () => i(s),
        children: (c = a.label) != null ? c : a.title
      }, (d = a.label) != null ? d : a.title);
    })
  });
};
function lh(e) {
  return function(i) {
    const {
      node: l,
      summaryCell: r
    } = i;
    if (!r)
      return l.rowPinned ? null : e(i);
    const o = r(i), {
      rowPinned: a
    } = l;
    if (o) {
      const {
        summaryCellTop: s,
        summaryCellBottom: c
      } = o;
      if (a === "top" && s)
        return Array.isArray(s) ? /* @__PURE__ */ n(An, {
          items: s
        }) : /* @__PURE__ */ n(Tn, {
          ...s
        });
      if (a === "bottom" && c)
        return Array.isArray(c) ? /* @__PURE__ */ n(An, {
          items: c
        }) : /* @__PURE__ */ n(Tn, {
          ...c
        });
    }
    return e(i);
  };
}
const rh = (e, ...t) => t.reduce((i, l) => (r) => i(l(r)), e), Di = rh(Hu, Yt, nh, Gu, lh, $u, Qu, Bu, eh), oh = "_wrapper_105iv_1", ah = "_content_105iv_10", sh = "_left_105iv_17", ch = "_center_105iv_21", dh = "_right_105iv_25", It = {
  wrapper: oh,
  content: ah,
  left: sh,
  center: ch,
  right: dh
}, uh = /* @__PURE__ */ new Set(["numberDecimal", "numberCurrency"]), On = (e) => typeof e == "string" || typeof e == "number";
function se(e) {
  function t(i) {
    var f, y;
    const l = ((f = i.colDef) == null ? void 0 : f.autoHeight) === !0, r = (y = i.colDef) == null ? void 0 : y.type, a = r != null && !Array.isArray(r) && uh.has(r) ? "right" : void 0, {
      left: s,
      primaryContent: c,
      secondaryContent: d,
      right: u,
      align: _
    } = e(i), p = On(c) ? /* @__PURE__ */ n(ue, {
      lines: l ? 0 : 1,
      size: "medium",
      align: _ != null ? _ : a,
      showTooltip: !0,
      weight: i.node.group ? "semi-bold" : "normal",
      children: c
    }) : c, m = On(d) ? /* @__PURE__ */ n(ue, {
      tone: "secondary",
      lines: l ? 0 : 1,
      size: "small",
      showTooltip: !0,
      align: _ != null ? _ : a,
      children: d
    }) : d;
    return /* @__PURE__ */ h("div", {
      className: It.wrapper,
      children: [s != null ? s : null, /* @__PURE__ */ h("div", {
        className: g(It.content, _ && It[_]),
        children: [p, d ? m : null]
      }), u != null ? u : null]
    });
  }
  return Di(t);
}
function hh(e) {
  const t = [];
  if (Object.keys(e).forEach((i) => {
    const l = i;
    e[l] === !0 && t.push(l);
  }), t.length > 1)
    throw Error(`Only one conditional may pass at any given time. Keys [${t.join(", ")}] evaluated to true`);
  return t[0];
}
function _h(e) {
  return e === "asc" || e == null ? /* @__PURE__ */ n(Ni, {
    size: "20"
  }) : /* @__PURE__ */ n(Ci, {
    size: "20"
  });
}
const Ri = (e) => {
  const {
    column: t,
    setSort: i,
    enableSorting: l,
    progressSort: r
  } = e, [o, a] = k(() => {
    var c;
    return (c = t.getSort()) != null ? c : null;
  });
  if (z(() => {
    function c() {
      var u;
      const d = (u = t.getSort()) != null ? u : null;
      a(d);
    }
    return t.addEventListener("sortChanged", c), () => t.removeEventListener("sortChanged", c);
  }, [t]), !l)
    return {
      sortIcon: null,
      sortOrder: o,
      sortColumn: () => {
      },
      progressSort: () => {
      }
    };
  const s = (c) => {
    !l || i(c);
  };
  return {
    sortIcon: _h(o),
    sortOrder: o,
    sortColumn: s,
    progressSort: r
  };
}, ph = (e) => {
  const {
    columnApi: t,
    column: i
  } = e, l = i.getColId(), r = (o) => {
    var c;
    const a = i.getParent();
    if (a != null) {
      const d = (c = a.getChildren()) != null ? c : [];
      t.setColumnsPinned(d.map((u) => u.getUniqueId()), o);
    } else
      t.setColumnPinned(l, o);
  };
  return {
    pinColumn: (o) => {
      r(o);
    }
  };
}, mh = {
  sorting: !1,
  resize: !1,
  hide: !1,
  move: !1,
  pinLeft: !1,
  pinRight: !1
}, fh = ({
  params: e,
  suppressedMenuItems: t,
  customMenuItems: i = []
}) => {
  const {
    sortable: l,
    suppressMovable: r,
    resizable: o
  } = e.column.getColDef(), {
    sortColumn: a,
    sortOrder: s
  } = Ri(e), {
    pinColumn: c
  } = ph(e), {
    dispatch: d
  } = vt(), u = {
    ...mh,
    ...t
  }, p = [...[l && !u.sorting ? /* @__PURE__ */ n(ae, {
    onClick: (m) => {
      a("asc", m);
    },
    icon: /* @__PURE__ */ n(Ni, {
      size: "20"
    }),
    disabled: s === "asc",
    children: "Sort Ascending"
  }) : null, l && !u.sorting ? /* @__PURE__ */ n(ae, {
    onClick: (m) => {
      a("desc", m);
    },
    icon: /* @__PURE__ */ n(Ci, {
      size: "20"
    }),
    disabled: s === "desc",
    children: "Sort Descending"
  }) : null, !u.pinLeft && /* @__PURE__ */ n(ae, {
    onClick: () => {
      c("left");
    },
    icon: /* @__PURE__ */ n(Su, {
      size: "20"
    }),
    disabled: e.column.isPinnedLeft(),
    children: "Pin Left"
  }), !u.pinRight && /* @__PURE__ */ n(ae, {
    onClick: () => {
      c("right");
    },
    icon: /* @__PURE__ */ n(Eu, {
      size: "20"
    }),
    disabled: e.column.isPinnedRight(),
    children: "Pin Right"
  }), !(u.pinLeft && u.pinRight) && /* @__PURE__ */ n(ae, {
    onClick: () => {
      c(null);
    },
    icon: /* @__PURE__ */ n(ki, {
      size: "20"
    }),
    disabled: !e.column.isPinned(),
    children: "Unpin"
  }), !u.move && !r && /* @__PURE__ */ n(ae, {
    onClick: () => {
      d({
        type: xi,
        payload: {
          isDraggingColumn: !0
        }
      });
    },
    icon: /* @__PURE__ */ n(pu, {
      size: "20"
    }),
    children: "Move Columns"
  }), !u.hide && /* @__PURE__ */ n(ae, {
    onClick: () => {
      e.columnApi.setColumnVisible(e.column.getColId(), !1);
    },
    icon: /* @__PURE__ */ n(Cu, {
      size: "20"
    }),
    children: "Hide"
  }), !u.resize && o && /* @__PURE__ */ n(ae, {
    onClick: () => {
      d({
        type: wi,
        payload: {
          isResizing: !0
        }
      });
    },
    icon: /* @__PURE__ */ n(Mu, {
      size: "20"
    }),
    children: "Resize"
  })], ...i];
  return /* @__PURE__ */ n(qt, {
    children: p.map((m) => m == null || m === !1 ? null : /* @__PURE__ */ n(Ft, {
      children: m
    }, m.props.children.toString()))
  });
}, gh = "_inline_1uws8_2", Te = {
  inline: gh,
  "inline-flex-child": "_inline-flex-child_1uws8_11",
  "sort-icon": "_sort-icon_1uws8_19",
  "is-sorting": "_is-sorting_1uws8_30",
  "is-draggable": "_is-draggable_1uws8_41"
}, vh = (e) => {
  switch (e) {
    case "asc":
    case "desc":
      return "Reverse Sort Direction";
    default:
      return "Sort";
  }
};
function oe(e) {
  return Yt((i) => {
    const {
      column: l,
      enableSorting: r
    } = i, {
      title: o,
      subtitle: a,
      information: s,
      suppressedMenuItems: c,
      customMenuItems: d = [],
      align: u = "left"
    } = e(i), {
      sortOrder: _,
      sortIcon: p,
      progressSort: m
    } = Ri(i), {
      state: {
        isLocked: f,
        isDraggingColumn: y
      }
    } = vt(), {
      autoHeaderHeight: w,
      suppressMovable: C
    } = l.getColDef(), v = hh({
      "flex-end": u === "right",
      center: u === "center",
      "flex-start": u === "left"
    }), x = !l.getColDef().suppressHeaderMenuButton;
    return /* @__PURE__ */ h(V, {
      className: g(Te.inline, !C && Te["is-draggable"], l.isSorting() && Te["is-sorting"]),
      onClick: (D) => {
        f || !r || m(D.shiftKey);
      },
      children: [/* @__PURE__ */ h("div", {
        className: g(Te.inline, Te["inline-flex-child"]),
        style: {
          justifyContent: v
        },
        children: [/* @__PURE__ */ n("div", {
          style: {
            minWidth: 0
          },
          children: /* @__PURE__ */ h(Kt, {
            children: [/* @__PURE__ */ n(ue, {
              showTooltip: !0,
              align: u,
              weight: "semi-bold",
              tone: l.isSorting() ? "primary" : "secondary",
              lines: w ? 0 : 1,
              children: o
            }), a ? /* @__PURE__ */ n(ue, {
              showTooltip: !0,
              align: u,
              weight: "normal",
              size: "small",
              tone: l.isSorting() ? "primary" : "secondary",
              lines: w ? 0 : 1,
              children: a
            }) : null]
          })
        }), s ? /* @__PURE__ */ n(ye, {
          label: s,
          children: /* @__PURE__ */ n("span", {
            children: /* @__PURE__ */ n(ku, {
              size: "20"
            })
          })
        }) : null, !f && p && /* @__PURE__ */ n("div", {
          className: Te["sort-icon"],
          children: /* @__PURE__ */ n(G, {
            variant: "subtle",
            label: vh(_),
            icon: p
          })
        }), y ? /* @__PURE__ */ n("div", {
          children: /* @__PURE__ */ n(fu, {
            direction: "vertical",
            size: "20"
          })
        }) : null]
      }), x && !f ? /* @__PURE__ */ h(Gt, {
        placement: "bottom-end",
        children: [/* @__PURE__ */ n(ft, {
          children: (D) => /* @__PURE__ */ n(G, {
            variant: "subtle",
            size: "md",
            label: "Menu",
            icon: /* @__PURE__ */ n(en, {}),
            ...D
          })
        }), /* @__PURE__ */ n(fh, {
          params: i,
          customMenuItems: d,
          suppressedMenuItems: c
        })]
      }) : null]
    });
  });
}
function bh() {
  return typeof window.ResizeObserver < "u";
}
function Si(e) {
  const {
    ref: t,
    onResize: i
  } = e;
  z(() => {
    const l = t == null ? void 0 : t.current;
    if (!l)
      return;
    if (!bh())
      return window.addEventListener("resize", i, !1), () => {
        window.removeEventListener("resize", i, !1);
      };
    const r = new window.ResizeObserver((o) => {
      !o.length || i();
    });
    return r.observe(l), () => {
      l && r.unobserve(l);
    };
  }, [i, t]);
}
const yh = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Ii = yh ? Hn : z;
function wh(e) {
  const [t, i] = k(e), l = E(t), r = E(null), o = H(() => {
    var c, d;
    let s = (c = r.current) == null ? void 0 : c.next();
    for (; !(s != null && s.done) && l.current === (s == null ? void 0 : s.value); )
      s = (d = r.current) == null ? void 0 : d.next();
    if (s != null && s.done) {
      r.current = null;
      return;
    }
    i(s == null ? void 0 : s.value), l.current = s == null ? void 0 : s.value;
  }, [i, l, r]);
  Ii(() => {
    r.current && o();
  });
  const a = H(
    (s) => {
      r.current = s(l.current), o();
    },
    [o, r, l]
  );
  return [t, a];
}
function xh(e) {
  return typeof e == "string";
}
function Ch(e) {
  return {
    text: e
  };
}
function Nh(e) {
  return {
    size: "sm",
    ...xh(e) ? Ch(e) : e
  };
}
const kh = "_wrapper_kuc8y_1", zh = "_lozenges_kuc8y_6", Dh = "_content_kuc8y_14", Rh = "_last_kuc8y_22", Je = {
  wrapper: kh,
  lozenges: zh,
  content: Dh,
  last: Rh
};
function Sh(e) {
  function t(i) {
    const {
      lozenges: l
    } = e(i);
    return /* @__PURE__ */ n("div", {
      className: Je.wrapper,
      children: /* @__PURE__ */ n(Ih, {
        children: l.map((r) => {
          const {
            text: o,
            ...a
          } = Nh(r);
          return /* @__PURE__ */ n(Qt, {
            ...a,
            children: o
          }, o);
        })
      })
    });
  }
  return Di(t);
}
function Ih({
  children: e
}) {
  const t = E(null), i = E(null), l = [];
  Mi.forEach(e, (d) => {
    $t(d) && l.push(d);
  });
  const [r, o] = wh(l.length), a = H(() => {
    const d = (u) => {
      const _ = i.current;
      if (!_)
        return u;
      const p = Array.from(_.children);
      if (p.length <= 0)
        return u;
      const m = _.offsetWidth, f = parseInt(getComputedStyle(_).gap, 10) || 0, y = l.length > u;
      let w = f * (u - 0), C = 0, v = l.length;
      if (y && (w += p.shift().offsetWidth, v--), p.length > 0) {
        const x = p.pop();
        x.style.overflow = "visible", w += x.offsetWidth, w < m && C++, x.style.overflow = "";
      }
      return p.forEach((x) => {
        w += x.offsetWidth, w < m && C++;
      }), Math.max(1, Math.min(v, C));
    };
    o(function* () {
      yield l.length;
      const _ = d(l.length);
      yield _, _ < l.length && _ > 1 && (yield d(_));
    });
  }, [l.length, o]);
  Si({
    ref: t,
    onResize: a
  });
  const s = E(null);
  Ii(() => {
    e !== s.current && (s.current = e, a());
  });
  let c = l;
  if (l.length > r) {
    const d = l.length - r;
    c = c.slice(0, r), c.push(/* @__PURE__ */ n("div", {
      className: Je.last,
      children: /* @__PURE__ */ n(Qt, {
        size: "sm",
        children: `+${d}`
      })
    }, "more-count"));
  }
  return /* @__PURE__ */ n("div", {
    ref: t,
    className: Je.lozenges,
    children: /* @__PURE__ */ n("div", {
      ref: i,
      className: Je.content,
      children: c
    })
  });
}
const Tt = {
  latestDate: (e) => e.values.reduce(
    (t, i) => Math.max(Number(t), Number(i)),
    -1 / 0
  ),
  earliestDate: (e) => e.values.reduce(
    (t, i) => Math.min(Number(t), Number(i)),
    1 / 0
  ),
  allLozenges: (e) => Array.from(new Set(e.values.flatMap((t) => t)))
};
function Et(e) {
  return e ? /^-?[0-9]+$/.test(e.toString()) || Number.isInteger(e) : !1;
}
const Eh = {
  text: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      title: e
    })),
    cellRenderer: se(({
      valueFormatted: e,
      value: t
    }) => ({
      primaryContent: e != null ? e : t
    }))
  },
  boolean: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      align: "center",
      title: e
    })),
    cellRenderer: se(({
      valueFormatted: e,
      value: t
    }) => ({
      align: "center",
      primaryContent: /* @__PURE__ */ n(Qt, {
        size: "sm",
        children: e != null ? e : t
      })
    })),
    valueFormatter: ({
      value: e
    }) => e === !0 ? "Yes" : "No"
  },
  lozenge: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      align: "left",
      title: e
    })),
    cellRenderer: Sh(({
      value: e
    }) => ({
      align: "left",
      lozenges: e
    })),
    aggFunc: Tt.allLozenges
  },
  numberDecimal: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      title: e,
      align: "right"
    })),
    cellRenderer: se(({
      valueFormatted: e,
      value: t
    }) => ({
      align: "right",
      primaryContent: e != null ? e : t
    })),
    valueFormatter: ({
      value: e
    }) => new Intl.NumberFormat("en-US", {
      style: "decimal",
      signDisplay: "never"
    }).format(e),
    aggFunc: "sum"
  },
  numberCurrency: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      title: e,
      align: "right"
    })),
    cellRenderer: se((e) => {
      var t;
      return {
        align: "right",
        primaryContent: (t = e.valueFormatted) != null ? t : e.value
      };
    }),
    valueFormatter: ({
      value: e
    }) => new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      signDisplay: "auto",
      currencySign: "accounting"
    }).format(e),
    aggFunc: "sum"
  },
  date: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      title: e
    })),
    cellRenderer: se((e) => {
      var t;
      return {
        primaryContent: /* @__PURE__ */ n(ue, {
          size: "medium",
          weight: e.node.group ? "semi-bold" : "normal",
          showTooltip: !0,
          children: /* @__PURE__ */ n("time", {
            children: (t = e.valueFormatted) != null ? t : e.value
          })
        })
      };
    }),
    valueFormatter: ({
      value: e
    }) => e == null ? "" : Et(e) ? Se.fromMillis(Number(e)).toLocaleString(Se.DATE_MED) : "Invalid Date",
    aggFunc: Tt.latestDate
  },
  time: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      title: e
    })),
    cellRenderer: se((e) => {
      var t;
      return {
        align: "left",
        primaryContent: /* @__PURE__ */ n(ue, {
          size: "medium",
          weight: e.node.group ? "semi-bold" : "normal",
          showTooltip: !0,
          children: /* @__PURE__ */ n("time", {
            children: (t = e.valueFormatted) != null ? t : e.value
          })
        })
      };
    }),
    valueFormatter: ({
      value: e
    }) => e == null ? "" : Et(e) ? Se.fromMillis(Number(e)).toLocaleString(Se.TIME_WITH_SECONDS) : "Invalid Time",
    aggFunc: "max"
  },
  datetime: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      title: e
    })),
    cellRenderer: se((e) => {
      var t;
      return {
        primaryContent: /* @__PURE__ */ n(ue, {
          size: "medium",
          weight: e.node.group ? "semi-bold" : "normal",
          showTooltip: !0,
          children: /* @__PURE__ */ n("time", {
            children: (t = e.valueFormatted) != null ? t : e.value
          })
        })
      };
    }),
    valueFormatter: ({
      value: e
    }) => e == null ? "" : Et(e) ? Se.fromMillis(Number(e)).toLocaleString(Se.DATETIME_SHORT_WITH_SECONDS) : "Invalid Date",
    aggFunc: "max"
  },
  kpi: {
    headerComponent: oe(({
      displayName: e
    }) => ({
      title: e,
      align: "center"
    })),
    cellRenderer: se(({
      valueFormatted: e,
      value: t
    }) => ({
      align: "center",
      primaryContent: e != null ? e : t
    })),
    aggFunc: "avg"
  }
};
function Ph(e) {
  return e !== void 0 && !("children" in e);
}
const Mh = {
  cellRendererParams: {
    suppressCount: !0
  },
  headerComponent: oe(({ displayName: e }) => ({
    title: e
  })),
  cellRendererSelector: (e) => {
    var c;
    const t = e.api.getColumnDefs(), { field: i } = e.node, l = t == null ? void 0 : t.find((d) => Ph(d) ? d.field === i : !1), r = (c = l == null ? void 0 : l.colId) != null ? c : i, o = {
      component: se(({ valueFormatted: d, value: u }) => ({
        primaryContent: d != null ? d : u
      }))
    };
    if (!i || !r)
      return o;
    const a = e.api.getColumnDef(r), s = a == null ? void 0 : a.cellRenderer;
    return s ? {
      component: s
    } : o;
  }
}, Lh = {
  type: "text",
  resizable: !0,
  sortable: !0,
  cellEditorPopup: !0,
  cellClassRules: {
    "iris-editable-cell": (e) => {
      const { editable: t } = e.colDef;
      return typeof t == "function" ? t(e) : t != null ? t : !1;
    }
  },
  suppressHeaderMenuButton: !1,
  cellRenderer: se((e) => {
    var t;
    return {
      align: "left",
      primaryContent: (t = e.valueFormatted) != null ? t : e.value
    };
  })
}, Ae = {
  suppressDragLeaveHidesColumns: !0,
  enableRangeSelection: !0,
  animateRows: !0,
  rowSelection: "multiple",
  suppressFieldDotNotation: !0,
  suppressAggFuncInHeader: !0,
  defaultColDef: Lh,
  columnTypes: Eh,
  autoGroupColumnDef: Mh,
  tooltipShowDelay: 0,
  tooltipHideDelay: 1e7,
  tooltipMouseTrack: !0,
  ensureDomOrder: !0,
  alwaysShowVerticalScroll: !0,
  cellFadeDelay: 4e3,
  aggFuncs: Tt,
  suppressClickEdit: !0,
  suppressMultiSort: !0,
  columnMenu: "new",
  suppressContextMenu: !0
};
function Th(e) {
  const [t, i] = k(!1);
  return z(() => {
    if (!e.current || !e.current.api)
      return;
    const l = e.current;
    function r() {
      i(!0);
    }
    function o() {
      i(!1);
    }
    return l.api.addEventListener("cellEditingStarted", r), l.api.addEventListener("cellEditingStopped", o), () => {
      l.api.removeEventListener("cellEditingStarted", r), l.api.removeEventListener("cellEditingStopped", o);
    };
  }, [e]), t;
}
function Ah(e) {
  const [t, i] = k(e), l = E(null), r = H(() => {
    if (e !== "responsive")
      return;
    const o = l.current;
    !o || (o.clientWidth < 428 ? i("condensed") : o.clientWidth < 1440 ? i("base") : i("loose"));
  }, [e]);
  return Si({
    ref: l,
    onResize: r
  }), {
    tableSize: t,
    ref: l
  };
}
const At = (e) => {
  const t = e.flatMap((l) => {
    if ("children" in l) {
      const o = At(l.children);
      return Object.entries(o).map(([a, s]) => ({
        field: a,
        value: s
      }));
    }
    return {
      field: l.field,
      value: ""
    };
  }), i = {};
  return t.forEach(({ field: l, value: r }) => {
    if (l) {
      if (l in i)
        throw Error(`Duplicate field with the same name found: ${l} `);
      i[l] = r;
    }
  }), i;
}, Oh = (e, t) => (i) => {
  if (e && (e.current = i), t) {
    const l = t;
    typeof l == "function" ? l(i) : l.current = i;
  }
};
function Fh() {
  ol.setLicenseKey(
    "Using_this_{AG_Grid}_Enterprise_key_{AG-055855}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Clari_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{50}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_April_2025}____[v3]_[01]_MTc0MzgwNzYwMDAwMA==45a4aabc5d069152e773d46d9b569a3a"
  );
}
const $h = "_table_11e41_1", Ot = {
  "table-wrapper": "_table-wrapper_11e41_1",
  table: $h,
  "contain-scroll": "_contain-scroll_11e41_25"
};
Fh();
const Hh = b(({
  id: e,
  columnDefs: t,
  autoGroupColumnDef: i,
  defaultColDef: l,
  rowData: r,
  columnTypes: o,
  aggFuncs: a,
  size: s = "base",
  borderless: c = !1,
  showTopSummaryRow: d = !1,
  showBottomSummaryRow: u = !1,
  showVerticalDivider: _ = !1,
  className: p,
  onColumnGroupOpened: m,
  onGridReady: f,
  ...y
}, w) => {
  const {
    setTables: C
  } = Ge(Xt), v = E(null), x = Th(v), D = {
    columnDefs: t,
    rowData: r
  }, L = {
    context: {
      ...Ae.context,
      irisTableId: e
    },
    defaultColDef: {
      ...Ae.defaultColDef,
      ...l
    },
    columnTypes: {
      ...Ae.columnTypes,
      ...o
    },
    autoGroupColumnDef: {
      ...Ae.autoGroupColumnDef,
      ...i
    },
    className: g(c && "borderless", p),
    onGridReady: (R) => {
      C((Z) => ({
        ...Z,
        [e]: v.current
      })), f == null || f(R);
    },
    aggFuncs: {
      ...Ae.aggFuncs,
      ...a
    }
  }, T = {
    pinnedBottomRowData: u ? [At(t)] : [],
    pinnedTopRowData: d ? [At(t)] : [],
    undoRedoCellEditing: !0,
    enableCellChangeFlash: !0
  };
  return /* @__PURE__ */ h("div", {
    id: e,
    onClick: () => {
      var R;
      x && ((R = v.current) == null || R.api.stopEditing(!0));
    },
    className: g(Ot["table-wrapper"], x && "iris-is-editing-cell", _ && "show-vertical-divider"),
    children: [/* @__PURE__ */ n(nl, {
      ref: Oh(v, w),
      loadingCellRenderer: su,
      modules: [tl, rl, ll, il],
      ...Ae,
      ...y,
      ...L,
      ...D,
      ...T
    }, s), /* @__PURE__ */ n(uu, {
      id: e
    })]
  });
}), B_ = b(({
  size: e = "base",
  preventSwipeNavigation: t,
  ...i
}, l) => {
  const {
    tableSize: r,
    ref: o
  } = Ah(e);
  return /* @__PURE__ */ n(Hd, {
    children: /* @__PURE__ */ n("div", {
      ref: o,
      className: g("ag-theme-quartz", "ag-theme-clari", `ag-theme-clari-${e}`, Ot.table, t && Ot["contain-scroll"]),
      children: /* @__PURE__ */ n(Hh, {
        ref: l,
        ...i,
        size: r
      })
    })
  });
});
function Zh(e) {
  const t = E(null);
  return z(() => {
    const i = (l) => {
      t.current && !t.current.contains(l.target) && e();
    };
    return document.addEventListener("click", i, !0), () => {
      document.removeEventListener("click", i, !0);
    };
  }, [t, e]), t;
}
const Bh = "_container_1wywp_1", Vh = "_last_1wywp_16", jh = "_first_1wywp_20", Gh = "_warning_1wywp_24", Wh = "_error_1wywp_32", qh = "_editor_1wywp_41", Uh = "_header_1wywp_45", Kh = "_title_1wywp_52", Qh = "_body_1wywp_57", Yh = "_footer_1wywp_61", X = {
  container: Bh,
  last: Vh,
  first: jh,
  warning: Gh,
  error: Wh,
  editor: qh,
  header: Uh,
  title: Kh,
  body: Qh,
  footer: Yh,
  "footer-action": "_footer-action_1wywp_69"
};
async function Jh(e, t, i, l = (r) => r) {
  const r = e.column.getColDef();
  function o(c) {
    var u, _;
    const d = (_ = (u = r.cellRendererParams) == null ? void 0 : u.loading) != null ? _ : [];
    e.column.setColDef({
      ...r,
      cellRendererParams: {
        ...r.cellRendererParams,
        loading: c ? [...d, e.node.id] : [...d].filter((p) => p === e.node.id)
      }
    }, r, "api");
  }
  function a(c) {
    e.column.setColDef({
      ...r,
      editable: !c,
      cellRendererParams: {
        ...r.cellRendererParams,
        error: c,
        nodeId: e.node.id
      }
    }, r, "api");
  }
  if (e.newValue === void 0 || JSON.stringify(l(e.oldValue)) === JSON.stringify(e.newValue))
    return;
  o(!0);
  let s;
  try {
    s = await i(t);
  } catch {
    s = !1;
  }
  if (o(!1), s === !1)
    a(!0), e.api.undoCellEditing(), setTimeout(() => {
      a(!1);
    }, 4e3);
  else {
    if (e.rowIndex == null)
      return;
    const c = e.column.getColId(), d = e.api.getDisplayedRowAtIndex(e.rowIndex);
    if (!d)
      return;
    e.api.flashCells({
      rowNodes: [d],
      columns: [c]
    });
  }
}
const Oe = $e(b((e, t) => {
  var J, we;
  const {
    title: i,
    hideTitle: l,
    helperText: r,
    initialValue: o,
    suppressKeys: a,
    width: s,
    disableEditorUI: c,
    onSave: d,
    body: u,
    valueGetter: _,
    validator: p,
    params: m
  } = e, {
    stopEditing: f
  } = m, [y, w] = k(o), [C, v] = k(null), [x, D] = k("default"), L = Zh(() => m.api.stopEditing(!0));
  if (Li(t, () => ({
    getValue() {
      return _ ? _(y) : y;
    }
  })), z(() => {
    const F = (K) => {
      Jh(K, y, d, _);
    };
    return m.api.addEventListener("cellEditingStopped", F), () => {
      m.api.removeEventListener("cellEditingStopped", F);
    };
  }, [d, _, y, m.api]), z(() => {
    var F, K, ie;
    if (p) {
      const le = (F = p.error) == null ? void 0 : F.call(p, y), Re = (K = p.warning) == null ? void 0 : K.call(p, y);
      le || Re ? (v((ie = le != null ? le : Re) != null ? ie : null), D(le ? "critical" : "warning")) : (v(null), D("default"));
    }
  }, [y, p]), z(() => {
    const F = m.column.getColDef();
    return m.column.setColDef({
      ...F,
      suppressKeyboardEvent(K) {
        return a != null && a.includes(K.event.key) || x === "critical" && K.event.key === "Enter" ? !0 : (K.event.key === "Tab" && m.api.stopEditing(!0), !1);
      }
    }, F, "api"), () => {
      m.column.setColDef({
        ...F,
        suppressKeyboardEvent: void 0
      }, F, "api");
    };
  }, [x, m.column, m.api, a]), c)
    return u({
      value: y,
      setValue: w
    });
  const T = (J = m.colDef.headerName) != null ? J : m.colDef.field, P = m.columnApi.getAllDisplayedColumns(), R = m.column.getColId(), Z = P.length !== 0 && R === P[0].getColId(), $ = P.length !== 0 && R === P[P.length - 1].getColId(), Y = s != null ? s : m.column.getActualWidth();
  return /* @__PURE__ */ n("div", {
    ref: L,
    className: g(X.container, Z && X.first, $ && X.last, x === "critical" && X.error, x === "warning" && X.warning),
    onClick: (F) => F.stopPropagation(),
    children: /* @__PURE__ */ h("div", {
      className: X.editor,
      style: {
        width: Y
      },
      children: [l ? null : /* @__PURE__ */ h("div", {
        className: X.header,
        children: [/* @__PURE__ */ n("div", {
          className: X.title,
          children: /* @__PURE__ */ n(ze, {
            variant: "label",
            size: "medium",
            children: i != null ? i : T
          })
        }), /* @__PURE__ */ n(G, {
          label: "Close",
          size: "md",
          variant: "subtle",
          icon: /* @__PURE__ */ n(ki, {}),
          onClick: () => m.api.stopEditing(!0)
        })]
      }), /* @__PURE__ */ n("div", {
        className: X.body,
        children: u({
          value: y,
          setValue: w
        })
      }), /* @__PURE__ */ h("div", {
        className: X.footer,
        children: [/* @__PURE__ */ n(ze, {
          size: "small",
          tone: x === "default" ? "tertiary" : "primary",
          weight: x !== "default" ? "semi-bold" : "normal",
          children: C != null ? C : r
        }), /* @__PURE__ */ n("div", {
          className: X["footer-action"],
          children: /* @__PURE__ */ n(he, {
            disabled: x === "critical" || !!((we = p == null ? void 0 : p.disableSave) != null && we.call(p, y)),
            tone: "accent",
            size: "sm",
            variant: "transparent",
            onClick: () => f(),
            children: "Save"
          })
        })]
      })]
    })
  });
})), Xh = "_wrapper_1e3ir_1", e_ = "_toggle_1e3ir_11", t_ = "_icon_1e3ir_30", n_ = "_checked_1e3ir_33", i_ = "_unchecked_1e3ir_37", Ve = {
  wrapper: Xh,
  toggle: e_,
  icon: t_,
  checked: n_,
  unchecked: i_
}, ce = 24, l_ = /* @__PURE__ */ n("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: ce,
  height: ce,
  fill: "none",
  children: /* @__PURE__ */ n("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 19.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5.78-.477 2.122 2.121 4.773-4.773 1.06 1.061-5.833 5.834-3.182-3.182 1.06-1.061Z",
    clipRule: "evenodd"
  })
}), r_ = /* @__PURE__ */ n("svg", {
  width: ce,
  height: ce,
  fill: "none",
  children: /* @__PURE__ */ n("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 12a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0ZM12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z",
    clipRule: "evenodd"
  })
}), tn = b(({
  id: e,
  checked: t,
  customIcon: i,
  onChange: l,
  ...r
}, o) => {
  const a = i && i.checked ? N(i.checked, {
    style: {
      width: ce,
      height: ce
    }
  }) : l_, s = i && i.unchecked ? N(i.unchecked, {
    style: {
      width: ce,
      height: ce
    }
  }) : r_;
  return /* @__PURE__ */ h("div", {
    className: g(Ve.wrapper),
    children: [/* @__PURE__ */ n("input", {
      ...r,
      style: {
        width: ce,
        height: ce
      },
      className: g(Ve.toggle),
      ref: o,
      id: e,
      type: "checkbox",
      checked: t,
      onChange: l
    }), /* @__PURE__ */ n("div", {
      className: g(Ve.icon, t ? Ve.checked : Ve.unchecked),
      children: t ? a : s
    })]
  });
});
tn.displayName = "IconToggle";
const o_ = "_body_16zzk_1", tt = {
  body: o_,
  "icon-radio-toggle-body": "_icon-radio-toggle-body_16zzk_8",
  "icon-radio-toggle": "_icon-radio-toggle_16zzk_8",
  "icon-radio-toggle-label": "_icon-radio-toggle-label_16zzk_21"
}, a_ = ({
  id: e,
  variant: t,
  value: i,
  label: l,
  secondaryLabel: r,
  customIcon: o,
  onChange: a
}) => {
  const s = E(null);
  z(() => {
    !s.current || s.current.focus();
  }, []);
  const c = i === !0;
  return /* @__PURE__ */ h("div", {
    className: tt.body,
    children: [/* @__PURE__ */ h("div", {
      style: {
        display: "flex",
        alignItems: "center"
      },
      children: [t === "switch" && /* @__PURE__ */ n(bi, {
        ref: s,
        id: e,
        size: "xs",
        checked: i,
        onChange: a
      }), t === "checkbox" && /* @__PURE__ */ n(ui, {
        ref: s,
        id: e,
        checked: i,
        onChange: a
      }), t === "icon-toggle" && /* @__PURE__ */ n(tn, {
        ref: s,
        id: e,
        customIcon: o,
        checked: i,
        onChange: a
      })]
    }), /* @__PURE__ */ n("label", {
      htmlFor: e,
      style: {
        flex: 1
      },
      children: c ? l : r != null ? r : l
    })]
  });
}, Fn = ({
  id: e,
  customIcon: t,
  checked: i,
  onChange: l,
  label: r
}) => /* @__PURE__ */ h("div", {
  className: tt["icon-radio-toggle"],
  children: [/* @__PURE__ */ n(tn, {
    id: e,
    customIcon: t,
    checked: i,
    onChange: l
  }), /* @__PURE__ */ n("label", {
    htmlFor: e,
    className: tt["icon-radio-toggle-label"],
    children: r
  })]
}), s_ = ({
  customIcon: e,
  value: t,
  label: i,
  secondaryId: l,
  secondaryLabel: r,
  primaryId: o,
  setValue: a
}) => /* @__PURE__ */ h("div", {
  className: tt["icon-radio-toggle-body"],
  children: [/* @__PURE__ */ n(Fn, {
    id: o,
    label: i,
    checked: t,
    customIcon: e,
    onChange: () => a(!0)
  }), /* @__PURE__ */ n(Fn, {
    id: l,
    label: r,
    checked: !t,
    customIcon: e,
    onChange: () => a(!1)
  })]
}), V_ = (e) => $e(b((t, i) => {
  const {
    title: l,
    helperText: r,
    label: o,
    secondaryLabel: a,
    customIcon: s,
    variant: c = "switch",
    onSave: d
  } = e(t), {
    value: u,
    node: _
  } = t;
  return /* @__PURE__ */ n(Oe, {
    ref: i,
    onSave: d,
    title: l,
    initialValue: u,
    helperText: r,
    params: t,
    body: ({
      setValue: p,
      value: m
    }) => {
      var y, w, C;
      const f = () => p((v) => !v);
      return c === "icon-radio" ? /* @__PURE__ */ n(s_, {
        primaryId: `editor--${(y = _.id) != null ? y : _.childIndex.toString()}-primary`,
        secondaryId: `editor--${(w = _.id) != null ? w : _.childIndex.toString()}-secondary`,
        customIcon: s,
        label: o != null ? o : "",
        secondaryLabel: a != null ? a : "",
        setValue: p,
        value: m
      }) : /* @__PURE__ */ n(a_, {
        id: `editor--${(C = _.id) != null ? C : _.childIndex.toString()}`,
        variant: c,
        value: m,
        label: o,
        secondaryLabel: a,
        customIcon: s,
        onChange: f
      });
    }
  });
})), j_ = (e) => $e(b((t, i) => {
  const {
    toolbar: l,
    dateRangePicker: r,
    helperText: o,
    onSave: a
  } = e(t);
  return r ? /* @__PURE__ */ n(Oe, {
    ref: i,
    hideTitle: !0,
    onSave: a,
    helperText: o,
    params: t,
    initialValue: {
      startDate: t.value === null ? new Date() : new Date(Number(t.value.startDate)),
      endDate: t.value === null ? new Date() : new Date(Number(t.value.endDate))
    },
    suppressKeys: ["Enter"],
    width: "initial",
    valueGetter: ({
      startDate: s,
      endDate: c
    }) => {
      if (!(!s || !c))
        return {
          startDate: new Date(s).getTime(),
          endDate: new Date(c).getTime()
        };
    },
    body: ({
      setValue: s,
      value: c
    }) => /* @__PURE__ */ n(wn, {
      toolbar: l,
      dateRangePicker: !0,
      onChange: ({
        startDate: d,
        endDate: u
      }) => {
        s({
          startDate: d,
          endDate: u
        });
      },
      value: c
    }),
    validator: {
      disableSave: (s) => s.startDate === void 0 || s.endDate === void 0
    }
  }) : /* @__PURE__ */ n(Oe, {
    ref: i,
    hideTitle: !0,
    onSave: a,
    helperText: o,
    params: t,
    initialValue: t.value === null ? new Date() : new Date(Number(t.value)),
    width: "initial",
    valueGetter: (s) => new Date(s).getTime(),
    body: ({
      setValue: s,
      value: c
    }) => /* @__PURE__ */ n(wn, {
      toolbar: l,
      onChange: s,
      value: c
    })
  });
})), c_ = "_body_1ro8r_1", d_ = "_input_1ro8r_17", Pt = {
  body: c_,
  "has-badge": "_has-badge_1ro8r_8",
  input: d_
}, $n = {
  BACKSPACE: "Backspace",
  DELETE: "Delete"
}, u_ = ({
  badge: e,
  params: t,
  value: i,
  setValue: l
}) => {
  var u, _;
  const r = ((u = t.colDef) == null ? void 0 : u.type) === "numberDecimal" || ((_ = t.colDef) == null ? void 0 : _.type) === "numberCurrency", a = H(() => {
    let p, m = !0;
    return t.eventKey === $n.BACKSPACE || t.eventKey === $n.DELETE ? p = "" : t.charPress ? (p = t.charPress, m = !1) : p = t.value, {
      value: p,
      highlightAllOnFocus: m
    };
  }, [t.charPress, t.eventKey, t.value])(), [s, c] = k(a.highlightAllOnFocus), d = E(null);
  return z(() => {
    l(a.value);
  }, [a.value, l]), z(() => {
    const p = d.current;
    if (p.focus(), s)
      p.select(), c(!1);
    else {
      const m = p.value ? p.value.length : 0;
      m > 0 && !r && p.setSelectionRange(m, m);
    }
  }, [s, r]), /* @__PURE__ */ h("div", {
    className: g(Pt.body, e && Pt["has-badge"]),
    children: [e ? N(e, {
      size: "sm"
    }) : null, r ? /* @__PURE__ */ n("input", {
      ref: d,
      inputMode: "decimal",
      type: "number",
      value: i,
      className: Pt.input,
      onChange: (p) => l(p.currentTarget.value)
    }) : /* @__PURE__ */ n(fd, {
      "aria-labelledby": "textarea",
      id: "textarea",
      ref: d,
      value: i,
      onChange: (p) => l(p.currentTarget.value),
      unstyled: !0
    })]
  });
}, G_ = (e) => $e(b((t, i) => {
  const {
    badge: l,
    title: r,
    helperText: o,
    validator: a,
    onSave: s
  } = e(t);
  return /* @__PURE__ */ n(Oe, {
    ref: i,
    onSave: s,
    title: r,
    helperText: o,
    params: t,
    initialValue: t.value,
    validator: a,
    body: ({
      setValue: c,
      value: d
    }) => /* @__PURE__ */ n(u_, {
      badge: l,
      params: t,
      value: d,
      setValue: c
    })
  });
})), W_ = (e) => $e(b((t, i) => {
  const {
    dialog: l,
    onSave: r,
    initialValue: o
  } = e(t), {
    api: a
  } = t;
  return /* @__PURE__ */ n("div", {
    onClick: (s) => {
      s.stopPropagation();
    },
    children: /* @__PURE__ */ n(Oe, {
      ref: i,
      params: t,
      initialValue: o != null ? o : null,
      onSave: r,
      disableEditorUI: !0,
      body: ({
        value: s,
        setValue: c
      }) => l({
        value: s,
        setValue: c,
        open: !0,
        onOpenChange: () => a.stopEditing(!0)
      })
    })
  });
})), q_ = (e) => $e(b((t, i) => {
  const {
    title: l,
    helperText: r,
    options: o,
    multiSelect: a = !1,
    onSave: s
  } = e(t), c = o.map(({
    disabled: p,
    ...m
  }) => ({
    ...m,
    isDisabled: p
  })), d = new Set(o.map((p) => p.value)), u = t.value, _ = c.filter((p) => a ? u.includes(p.value) : p.value === u);
  if (!a && !d.has(t.value))
    throw Error(`Selected option "${t.value}" does not exist in provided option list`);
  if (a && !u.every((p) => d.has(p)))
    throw Error(`Selected options "${JSON.stringify(t.value)}" do not exist in provided option list`);
  return /* @__PURE__ */ n(Oe, {
    ref: i,
    initialValue: u,
    onSave: s,
    title: l,
    helperText: r,
    params: t,
    suppressKeys: ["Enter", "Tab"],
    body: ({
      setValue: p
    }) => /* @__PURE__ */ n("div", {
      style: {
        padding: "8px"
      },
      children: /* @__PURE__ */ n(pa, {
        tabSelectsValue: !1,
        defaultValue: _,
        disableFloatingMenu: !0,
        autoFocus: !0,
        menuIsOpen: !0,
        isMulti: a,
        options: c,
        onChange: (m) => {
          var y;
          const f = a ? m.map((w) => w.value) : (y = m == null ? void 0 : m.value) != null ? y : null;
          p(f);
        }
      })
    })
  });
}));
export {
  $_ as HeaderGroup,
  Ih as LozengeContainer,
  B_ as Table,
  Xt as TableContext,
  H_ as TableProvider,
  ue as TableText,
  se as cellRenderer,
  V_ as createBooleanEditor,
  j_ as createDatePickerEditor,
  G_ as createDefaultEditor,
  W_ as createDialogEditor,
  oe as createHeaderCell,
  q_ as createPicklistEditor,
  Sh as lozengeRenderer,
  Z_ as useTable,
  Di as withBaseCellRenderer,
  $u as withCellActions,
  Qu as withGroupRenderer,
  eh as withHoverCardParam,
  lh as withSummaryCellParams
};
